// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies
// @generated from protobuf file "common.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message proto.UnitStats
 */
export interface UnitStats {
    /**
     * @generated from protobuf field: repeated double stats = 1;
     */
    stats: number[];
    /**
     * @generated from protobuf field: repeated double pseudo_stats = 2;
     */
    pseudoStats: number[];
}
/**
 * Buffs that affect the entire raid.
 *
 * @generated from protobuf message proto.RaidBuffs
 */
export interface RaidBuffs {
    /**
     * +Stats
     *
     * @generated from protobuf field: proto.TristateEffect gift_of_the_wild = 1;
     */
    giftOfTheWild: TristateEffect;
    /**
     * +Stam
     *
     * @generated from protobuf field: proto.TristateEffect power_word_fortitude = 2;
     */
    powerWordFortitude: TristateEffect;
    /**
     * +Health
     *
     * @generated from protobuf field: proto.TristateEffect commanding_shout = 3;
     */
    commandingShout: TristateEffect;
    /**
     * @generated from protobuf field: proto.TristateEffect blood_pact = 4;
     */
    bloodPact: TristateEffect;
    /**
     * + Agi and Str
     *
     * @generated from protobuf field: bool horn_of_winter = 5;
     */
    hornOfWinter: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect strength_of_earth_totem = 6;
     */
    strengthOfEarthTotem: TristateEffect; // none, normal, 15% improved    /**
     * +Intell and/or Spi
     *
     * @generated from protobuf field: bool arcane_brilliance = 7;
     */
    arcaneBrilliance: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect fel_intelligence = 8;
     */
    felIntelligence: TristateEffect;
    /**
     * @generated from protobuf field: bool divine_spirit = 9;
     */
    divineSpirit: boolean;
    /**
     * +AP
     *
     * @generated from protobuf field: proto.TristateEffect battle_shout = 10;
     */
    battleShout: TristateEffect;
    /**
     * 10% AP
     *
     * @generated from protobuf field: bool trueshot_aura = 11;
     */
    trueshotAura: boolean;
    /**
     * @generated from protobuf field: bool unleashed_rage = 12;
     */
    unleashedRage: boolean;
    /**
     * @generated from protobuf field: bool abominations_might = 13;
     */
    abominationsMight: boolean;
    /**
     * 5% phy crit
     *
     * @generated from protobuf field: proto.TristateEffect leader_of_the_pack = 14;
     */
    leaderOfThePack: TristateEffect;
    /**
     * @generated from protobuf field: bool rampage = 15;
     */
    rampage: boolean;
    /**
     * 20% Melee Haste
     *
     * @generated from protobuf field: bool icy_talons = 16;
     */
    icyTalons: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect windfury_totem = 17;
     */
    windfuryTotem: TristateEffect; // none, 16%, 20%    /**
     * +Spell Power
     *
     * @generated from protobuf field: bool totem_of_wrath = 18;
     */
    totemOfWrath: boolean;
    /**
     * @generated from protobuf field: bool flametongue_totem = 19;
     */
    flametongueTotem: boolean;
    /**
     * @generated from protobuf field: int32 demonic_pact = 43;
     */
    demonicPact: number; // SP buff -- deprecated.    /**
     * +5% Spell Crit and/or +3% Haste
     *
     * @generated from protobuf field: bool swift_retribution = 21;
     */
    swiftRetribution: boolean; // haste only    /**
     * @generated from protobuf field: proto.TristateEffect moonkin_aura = 22;
     */
    moonkinAura: TristateEffect; // both crit and haste    /**
     * @generated from protobuf field: bool elemental_oath = 23;
     */
    elementalOath: boolean; // crit only    /**
     * 5% spell haste
     *
     * @generated from protobuf field: bool wrath_of_air_totem = 24;
     */
    wrathOfAirTotem: boolean;
    /**
     * 3% dmg
     *
     * @generated from protobuf field: bool ferocious_inspiration = 25;
     */
    ferociousInspiration: boolean;
    /**
     * @generated from protobuf field: bool sanctified_retribution = 26;
     */
    sanctifiedRetribution: boolean;
    /**
     * @generated from protobuf field: bool arcane_empowerment = 27;
     */
    arcaneEmpowerment: boolean;
    /**
     * mp5
     *
     * @generated from protobuf field: proto.TristateEffect mana_spring_totem = 28;
     */
    manaSpringTotem: TristateEffect;
    /**
     * Resistances
     *
     * @generated from protobuf field: bool shadow_protection = 33;
     */
    shadowProtection: boolean;
    /**
     * @generated from protobuf field: bool nature_resistance_totem = 45;
     */
    natureResistanceTotem: boolean;
    /**
     * @generated from protobuf field: bool aspect_of_the_wild = 46;
     */
    aspectOfTheWild: boolean;
    /**
     * @generated from protobuf field: bool frost_resistance_aura = 47;
     */
    frostResistanceAura: boolean;
    /**
     * @generated from protobuf field: bool frost_resistance_totem = 48;
     */
    frostResistanceTotem: boolean;
    /**
     * Miscellaneous
     *
     * @generated from protobuf field: bool bloodlust = 29;
     */
    bloodlust: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect thorns = 30;
     */
    thorns: TristateEffect;
    /**
     * @generated from protobuf field: proto.TristateEffect devotion_aura = 31;
     */
    devotionAura: TristateEffect;
    /**
     * @generated from protobuf field: proto.TristateEffect stoneskin_totem = 42;
     */
    stoneskinTotem: TristateEffect;
    /**
     * @generated from protobuf field: bool retribution_aura = 32;
     */
    retributionAura: boolean;
    /**
     * Drums
     *
     * @generated from protobuf field: bool drums_of_forgotten_kings = 34;
     */
    drumsOfForgottenKings: boolean;
    /**
     * @generated from protobuf field: bool drums_of_the_wild = 35;
     */
    drumsOfTheWild: boolean;
    /**
     * Scroll
     *
     * @generated from protobuf field: bool scroll_of_protection = 36;
     */
    scrollOfProtection: boolean;
    /**
     * @generated from protobuf field: bool scroll_of_stamina = 37;
     */
    scrollOfStamina: boolean;
    /**
     * @generated from protobuf field: bool scroll_of_strength = 38;
     */
    scrollOfStrength: boolean;
    /**
     * @generated from protobuf field: bool scroll_of_agility = 39;
     */
    scrollOfAgility: boolean;
    /**
     * @generated from protobuf field: bool scroll_of_intellect = 40;
     */
    scrollOfIntellect: boolean;
    /**
     * @generated from protobuf field: bool scroll_of_spirit = 41;
     */
    scrollOfSpirit: boolean;
}
/**
 * Buffs that affect a single party.
 *
 * @generated from protobuf message proto.PartyBuffs
 */
export interface PartyBuffs {
    /**
     * Item Buffs
     *
     * @generated from protobuf field: int32 atiesh_mage = 1;
     */
    atieshMage: number;
    /**
     * @generated from protobuf field: int32 atiesh_warlock = 2;
     */
    atieshWarlock: number;
    /**
     * @generated from protobuf field: bool braided_eternium_chain = 3;
     */
    braidedEterniumChain: boolean;
    /**
     * @generated from protobuf field: bool eye_of_the_night = 4;
     */
    eyeOfTheNight: boolean;
    /**
     * @generated from protobuf field: bool chain_of_the_twilight_owl = 5;
     */
    chainOfTheTwilightOwl: boolean;
    /**
     * Group buffs
     *
     * @generated from protobuf field: int32 mana_tide_totems = 6;
     */
    manaTideTotems: number;
    /**
     * @generated from protobuf field: bool heroic_presence = 7;
     */
    heroicPresence: boolean;
}
/**
 * These are usually individual actions taken by other Characters.
 *
 * @generated from protobuf message proto.IndividualBuffs
 */
export interface IndividualBuffs {
    /**
     * 10% Stats
     *
     * @generated from protobuf field: bool blessing_of_kings = 1;
     */
    blessingOfKings: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect blessing_of_wisdom = 2;
     */
    blessingOfWisdom: TristateEffect;
    /**
     * @generated from protobuf field: proto.TristateEffect blessing_of_might = 3;
     */
    blessingOfMight: TristateEffect;
    /**
     * @generated from protobuf field: bool blessing_of_sanctuary = 4;
     */
    blessingOfSanctuary: boolean;
    /**
     * @generated from protobuf field: bool vigilance = 5;
     */
    vigilance: boolean;
    /**
     * @generated from protobuf field: bool renewed_hope = 6;
     */
    renewedHope: boolean; // Only used in individual sims     //   as the class that provides these would cast them in raid sim    /**
     * How many of each of these buffs the player will be receiving.
     *
     * @generated from protobuf field: int32 hymn_of_hope = 7;
     */
    hymnOfHope: number;
    /**
     * @generated from protobuf field: int32 hand_of_salvation = 8;
     */
    handOfSalvation: number;
    /**
     * @generated from protobuf field: int32 rapture = 9;
     */
    rapture: number;
    /**
     * @generated from protobuf field: int32 innervates = 10;
     */
    innervates: number;
    /**
     * @generated from protobuf field: int32 power_infusions = 11;
     */
    powerInfusions: number;
    /**
     * @generated from protobuf field: int32 unholy_frenzy = 12;
     */
    unholyFrenzy: number;
    /**
     * @generated from protobuf field: int32 revitalize_rejuvination = 13;
     */
    revitalizeRejuvination: number;
    /**
     * @generated from protobuf field: int32 revitalize_wild_growth = 21;
     */
    revitalizeWildGrowth: number;
    /**
     * @generated from protobuf field: int32 tricks_of_the_trades = 19;
     */
    tricksOfTheTrades: number;
    /**
     * @generated from protobuf field: int32 divine_guardians = 23;
     */
    divineGuardians: number;
    /**
     * @generated from protobuf field: int32 pain_suppressions = 24;
     */
    painSuppressions: number;
    /**
     * @generated from protobuf field: int32 hand_of_sacrifices = 25;
     */
    handOfSacrifices: number;
    /**
     * @generated from protobuf field: int32 guardian_spirits = 26;
     */
    guardianSpirits: number;
    /**
     * Technically a debuff, but only used by individual sims.
     *
     * @generated from protobuf field: int32 shattering_throws = 20;
     */
    shatteringThrows: number;
    /**
     * Replenishment
     *
     * @generated from protobuf field: bool vampiric_touch = 14;
     */
    vampiricTouch: boolean;
    /**
     * @generated from protobuf field: bool hunting_party = 15;
     */
    huntingParty: boolean;
    /**
     * @generated from protobuf field: bool judgements_of_the_wise = 16;
     */
    judgementsOfTheWise: boolean;
    /**
     * @generated from protobuf field: bool improved_soul_leech = 17;
     */
    improvedSoulLeech: boolean;
    /**
     * @generated from protobuf field: bool enduring_winter = 18;
     */
    enduringWinter: boolean;
    /**
     * @generated from protobuf field: bool focus_magic = 22;
     */
    focusMagic: boolean;
}
/**
 * @generated from protobuf message proto.Consumes
 */
export interface Consumes {
    /**
     * @generated from protobuf field: proto.Flask flask = 1;
     */
    flask: Flask;
    /**
     * @generated from protobuf field: proto.BattleElixir battle_elixir = 2;
     */
    battleElixir: BattleElixir;
    /**
     * @generated from protobuf field: proto.GuardianElixir guardian_elixir = 3;
     */
    guardianElixir: GuardianElixir;
    /**
     * @generated from protobuf field: proto.WeaponImbue weapon_main = 4;
     */
    weaponMain: WeaponImbue;
    /**
     * @generated from protobuf field: proto.WeaponImbue weapon_off = 5;
     */
    weaponOff: WeaponImbue;
    /**
     * @generated from protobuf field: proto.Food food = 6;
     */
    food: Food;
    /**
     * @generated from protobuf field: proto.PetFood pet_food = 7;
     */
    petFood: PetFood;
    /**
     * @generated from protobuf field: int32 pet_scroll_of_agility = 8;
     */
    petScrollOfAgility: number;
    /**
     * @generated from protobuf field: int32 pet_scroll_of_strength = 9;
     */
    petScrollOfStrength: number;
    /**
     * @generated from protobuf field: proto.Potions default_potion = 10;
     */
    defaultPotion: Potions;
    /**
     * @generated from protobuf field: proto.Potions prepop_potion = 11;
     */
    prepopPotion: Potions;
    /**
     * @generated from protobuf field: proto.Conjured default_conjured = 12;
     */
    defaultConjured: Conjured;
    /**
     * @generated from protobuf field: bool super_sapper = 14;
     */
    superSapper: boolean;
    /**
     * @generated from protobuf field: bool thermal_sapper = 15;
     */
    thermalSapper: boolean;
    /**
     * @generated from protobuf field: bool explosive_decoy = 16;
     */
    explosiveDecoy: boolean;
    /**
     * @generated from protobuf field: proto.Explosive filler_explosive = 17;
     */
    fillerExplosive: Explosive;
}
/**
 * @generated from protobuf message proto.Debuffs
 */
export interface Debuffs {
    /**
     * @generated from protobuf field: bool judgement_of_wisdom = 1;
     */
    judgementOfWisdom: boolean;
    /**
     * @generated from protobuf field: bool judgement_of_light = 2;
     */
    judgementOfLight: boolean;
    /**
     * @generated from protobuf field: bool misery = 3;
     */
    misery: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect faerie_fire = 4;
     */
    faerieFire: TristateEffect;
    /**
     * 13% bonus spell damage
     *
     * @generated from protobuf field: bool curse_of_elements = 5;
     */
    curseOfElements: boolean;
    /**
     * @generated from protobuf field: bool ebon_plaguebringer = 6;
     */
    ebonPlaguebringer: boolean;
    /**
     * @generated from protobuf field: bool earth_and_moon = 7;
     */
    earthAndMoon: boolean;
    /**
     * +3% to crit against target
     *
     * @generated from protobuf field: bool heart_of_the_crusader = 8;
     */
    heartOfTheCrusader: boolean;
    /**
     * @generated from protobuf field: bool master_poisoner = 9;
     */
    masterPoisoner: boolean;
    /**
     * @generated from protobuf field: bool totem_of_wrath = 10;
     */
    totemOfWrath: boolean;
    /**
     * 5% spell crit
     *
     * @generated from protobuf field: bool shadow_mastery = 11;
     */
    shadowMastery: boolean;
    /**
     * @generated from protobuf field: bool improved_scorch = 12;
     */
    improvedScorch: boolean;
    /**
     * @generated from protobuf field: bool winters_chill = 13;
     */
    wintersChill: boolean;
    /**
     * @generated from protobuf field: bool blood_frenzy = 14;
     */
    bloodFrenzy: boolean;
    /**
     * @generated from protobuf field: bool savage_combat = 15;
     */
    savageCombat: boolean;
    /**
     * TODO: validate these
     *
     * @generated from protobuf field: bool gift_of_arthas = 16;
     */
    giftOfArthas: boolean;
    /**
     * Bleed %
     *
     * @generated from protobuf field: bool mangle = 17;
     */
    mangle: boolean;
    /**
     * @generated from protobuf field: bool trauma = 18;
     */
    trauma: boolean;
    /**
     * @generated from protobuf field: bool stampede = 19;
     */
    stampede: boolean;
    /**
     * Major armor
     *
     * @generated from protobuf field: bool expose_armor = 20;
     */
    exposeArmor: boolean;
    /**
     * @generated from protobuf field: bool sunder_armor = 21;
     */
    sunderArmor: boolean;
    /**
     * @generated from protobuf field: bool acid_spit = 22;
     */
    acidSpit: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect curse_of_weakness = 23;
     */
    curseOfWeakness: TristateEffect;
    /**
     * @generated from protobuf field: bool sting = 24;
     */
    sting: boolean;
    /**
     * @generated from protobuf field: bool spore_cloud = 37;
     */
    sporeCloud: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect demoralizing_roar = 25;
     */
    demoralizingRoar: TristateEffect;
    /**
     * @generated from protobuf field: proto.TristateEffect demoralizing_shout = 26;
     */
    demoralizingShout: TristateEffect;
    /**
     * @generated from protobuf field: bool vindication = 36;
     */
    vindication: boolean;
    /**
     * @generated from protobuf field: bool demoralizing_screech = 34;
     */
    demoralizingScreech: boolean;
    /**
     * @generated from protobuf field: proto.TristateEffect thunder_clap = 27;
     */
    thunderClap: TristateEffect;
    /**
     * @generated from protobuf field: proto.TristateEffect frost_fever = 28;
     */
    frostFever: TristateEffect;
    /**
     * @generated from protobuf field: bool infected_wounds = 29;
     */
    infectedWounds: boolean;
    /**
     * @generated from protobuf field: bool judgements_of_the_just = 30;
     */
    judgementsOfTheJust: boolean;
    /**
     * @generated from protobuf field: bool insect_swarm = 31;
     */
    insectSwarm: boolean;
    /**
     * @generated from protobuf field: bool scorpid_sting = 32;
     */
    scorpidSting: boolean;
    /**
     * @generated from protobuf field: bool shadow_embrace = 33;
     */
    shadowEmbrace: boolean;
    /**
     * 1 = normal, 2 = talented, 3 = talented+glyphed
     *
     * @generated from protobuf field: int32 hunters_mark = 35;
     */
    huntersMark: number;
    /**
     * @generated from protobuf field: bool crystal_yield = 38;
     */
    crystalYield: boolean;
}
/**
 * @generated from protobuf message proto.TargetInput
 */
export interface TargetInput {
    /**
     * @generated from protobuf field: proto.InputType input_type = 1;
     */
    inputType: InputType;
    /**
     * @generated from protobuf field: string label = 2;
     */
    label: string;
    /**
     * @generated from protobuf field: string tooltip = 5;
     */
    tooltip: string;
    /**
     * @generated from protobuf field: bool bool_value = 3;
     */
    boolValue: boolean;
    /**
     * @generated from protobuf field: double number_value = 4;
     */
    numberValue: number;
}
/**
 * @generated from protobuf message proto.Target
 */
export interface Target {
    /**
     * The in-game NPC ID.
     *
     * @generated from protobuf field: int32 id = 14;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 15;
     */
    name: string;
    /**
     * @generated from protobuf field: int32 level = 4;
     */
    level: number;
    /**
     * @generated from protobuf field: proto.MobType mob_type = 3;
     */
    mobType: MobType;
    /**
     * @generated from protobuf field: repeated double stats = 5;
     */
    stats: number[];
    /**
     * Auto attack parameters.
     *
     * @generated from protobuf field: double min_base_damage = 7;
     */
    minBaseDamage: number;
    /**
     * @generated from protobuf field: double damage_spread = 19;
     */
    damageSpread: number; // replaces tight_enemy_damage    /**
     * @generated from protobuf field: double swing_speed = 8;
     */
    swingSpeed: number;
    /**
     * @generated from protobuf field: bool dual_wield = 9;
     */
    dualWield: boolean;
    /**
     * @generated from protobuf field: bool dual_wield_penalty = 10;
     */
    dualWieldPenalty: boolean;
    /**
     * @generated from protobuf field: bool parry_haste = 12;
     */
    parryHaste: boolean;
    /**
     * @generated from protobuf field: bool tight_enemy_damage = 17;
     */
    tightEnemyDamage: boolean; // deprecated as of 07/12/23    /**
     * @generated from protobuf field: bool suppress_dodge = 16;
     */
    suppressDodge: boolean; // Sunwell Radiance    /**
     * @generated from protobuf field: proto.SpellSchool spell_school = 13;
     */
    spellSchool: SpellSchool; // Allows elemental attacks.    /**
     * Index in Raid.tanks indicating the player tanking this mob.
     * -1 or invalid index indicates not being tanked.
     *
     * @generated from protobuf field: int32 tank_index = 6;
     */
    tankIndex: number;
    /**
     * Custom Target AI parameters
     *
     * @generated from protobuf field: repeated proto.TargetInput target_inputs = 18;
     */
    targetInputs: TargetInput[];
}
/**
 * @generated from protobuf message proto.Encounter
 */
export interface Encounter {
    /**
     * @generated from protobuf field: double duration = 1;
     */
    duration: number;
    /**
     * Variation in the duration
     *
     * @generated from protobuf field: double duration_variation = 2;
     */
    durationVariation: number;
    /**
     * The ratio of the encounter duration, between 0 and 1, for which the targets
     * will be in execute range (<= 20%) for the purposes of Warrior Execute, Mage Molten
     * Fury, etc.
     *
     * @generated from protobuf field: double execute_proportion_20 = 3;
     */
    executeProportion20: number;
    /**
     * Key for Affliction warlock Drain Soul
     *
     * @generated from protobuf field: double execute_proportion_25 = 7;
     */
    executeProportion25: number;
    /**
     * Same as execute_proportion but for 35%.
     *
     * @generated from protobuf field: double execute_proportion_35 = 4;
     */
    executeProportion35: number;
    /**
     * If set, will use the targets health value instead of a duration for fight length.
     *
     * @generated from protobuf field: bool use_health = 5;
     */
    useHealth: boolean;
    /**
     * If type != Simple or Custom, then this may be empty.
     *
     * @generated from protobuf field: repeated proto.Target targets = 6;
     */
    targets: Target[];
}
/**
 * @generated from protobuf message proto.PresetTarget
 */
export interface PresetTarget {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: proto.Target target = 2;
     */
    target?: Target;
}
/**
 * @generated from protobuf message proto.PresetEncounter
 */
export interface PresetEncounter {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: repeated proto.PresetTarget targets = 2;
     */
    targets: PresetTarget[];
}
/**
 * @generated from protobuf message proto.ItemSpec
 */
export interface ItemSpec {
    /**
     * @generated from protobuf field: int32 id = 2;
     */
    id: number;
    /**
     * @generated from protobuf field: int32 enchant = 3;
     */
    enchant: number;
    /**
     * @generated from protobuf field: repeated int32 gems = 4;
     */
    gems: number[];
    /**
     * @generated from protobuf field: proto.Suffix suffix = 5;
     */
    suffix: Suffix;
    /**
     * @generated from protobuf field: int32 ilvl = 6;
     */
    ilvl: number;
    /**
     * @generated from protobuf field: proto.ItemQuality quality = 7;
     */
    quality: ItemQuality;
}
/**
 * @generated from protobuf message proto.EquipmentSpec
 */
export interface EquipmentSpec {
    /**
     * @generated from protobuf field: repeated proto.ItemSpec items = 1;
     */
    items: ItemSpec[];
}
/**
 * @generated from protobuf message proto.SimDatabase
 */
export interface SimDatabase {
    /**
     * @generated from protobuf field: repeated proto.SimItem items = 1;
     */
    items: SimItem[];
    /**
     * @generated from protobuf field: repeated proto.SimEnchant enchants = 2;
     */
    enchants: SimEnchant[];
    /**
     * @generated from protobuf field: repeated proto.SimGem gems = 3;
     */
    gems: SimGem[];
}
/**
 * Contains only the Item info needed by the sim.
 *
 * @generated from protobuf message proto.SimItem
 */
export interface SimItem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: proto.ItemType type = 3;
     */
    type: ItemType;
    /**
     * @generated from protobuf field: proto.ArmorType armor_type = 4;
     */
    armorType: ArmorType;
    /**
     * @generated from protobuf field: proto.WeaponType weapon_type = 5;
     */
    weaponType: WeaponType;
    /**
     * @generated from protobuf field: proto.HandType hand_type = 6;
     */
    handType: HandType;
    /**
     * @generated from protobuf field: proto.RangedWeaponType ranged_weapon_type = 7;
     */
    rangedWeaponType: RangedWeaponType;
    /**
     * @generated from protobuf field: repeated double stats = 8;
     */
    stats: number[];
    /**
     * @generated from protobuf field: repeated proto.GemColor gem_sockets = 9;
     */
    gemSockets: GemColor[];
    /**
     * @generated from protobuf field: repeated double socketBonus = 10;
     */
    socketBonus: number[];
    /**
     * @generated from protobuf field: double weapon_damage_min = 11;
     */
    weaponDamageMin: number;
    /**
     * @generated from protobuf field: double weapon_damage_max = 12;
     */
    weaponDamageMax: number;
    /**
     * @generated from protobuf field: double weapon_speed = 13;
     */
    weaponSpeed: number;
    /**
     * @generated from protobuf field: string set_name = 14;
     */
    setName: string;
    /**
     * @generated from protobuf field: proto.Suffix suffix = 15;
     */
    suffix: Suffix;
    /**
     * @generated from protobuf field: int32 ilvl = 16;
     */
    ilvl: number;
    /**
     * @generated from protobuf field: proto.ItemQuality quality = 17;
     */
    quality: ItemQuality;
}
/**
 * Contains only the Enchant info needed by the sim.
 *
 * @generated from protobuf message proto.SimEnchant
 */
export interface SimEnchant {
    /**
     * @generated from protobuf field: int32 effect_id = 1;
     */
    effectId: number;
    /**
     * @generated from protobuf field: repeated double stats = 2;
     */
    stats: number[];
}
/**
 * Contains only the Gem info needed by the sim.
 *
 * @generated from protobuf message proto.SimGem
 */
export interface SimGem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: proto.GemColor color = 3;
     */
    color: GemColor;
    /**
     * @generated from protobuf field: repeated double stats = 4;
     */
    stats: number[];
}
/**
 * @generated from protobuf message proto.UnitReference
 */
export interface UnitReference {
    /**
     * The type of unit being referenced.
     *
     * @generated from protobuf field: proto.UnitReference.Type type = 2;
     */
    type: UnitReference_Type;
    /**
     * Index of the player/target/pet/etc depending on value of type.
     *
     * @generated from protobuf field: int32 index = 3;
     */
    index: number;
    /**
     * Reference to the owner, only used iff this is a pet.
     *
     * @generated from protobuf field: proto.UnitReference owner = 4;
     */
    owner?: UnitReference;
    /**
     * Raid index of the player to target. A value of -1 indicates no target.
     * TODO: Delete this after 2 months (on or after 9/19/2023)
     *
     * @deprecated
     * @generated from protobuf field: int32 target_index = 1 [deprecated = true];
     */
    targetIndex: number;
}
/**
 * @generated from protobuf enum proto.UnitReference.Type
 */
export enum UnitReference_Type {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    Unknown = 0,
    /**
     * @generated from protobuf enum value: Player = 1;
     */
    Player = 1,
    /**
     * @generated from protobuf enum value: Target = 2;
     */
    Target = 2,
    /**
     * @generated from protobuf enum value: Pet = 3;
     */
    Pet = 3,
    /**
     * @generated from protobuf enum value: Self = 4;
     */
    Self = 4,
    /**
     * @generated from protobuf enum value: CurrentTarget = 5;
     */
    CurrentTarget = 5,
    /**
     * @generated from protobuf enum value: AllPlayers = 6;
     */
    AllPlayers = 6,
    /**
     * @generated from protobuf enum value: AllTargets = 7;
     */
    AllTargets = 7
}
/**
 * @generated from protobuf message proto.ActionID
 */
export interface ActionID {
    /**
     * @generated from protobuf oneof: raw_id
     */
    rawId: {
        oneofKind: "spellId";
        /**
         * @generated from protobuf field: int32 spell_id = 1;
         */
        spellId: number;
    } | {
        oneofKind: "itemId";
        /**
         * @generated from protobuf field: int32 item_id = 2;
         */
        itemId: number;
    } | {
        oneofKind: "otherId";
        /**
         * @generated from protobuf field: proto.OtherAction other_id = 3;
         */
        otherId: OtherAction;
    } | {
        oneofKind: undefined;
    };
    /**
     * Distinguishes between different versions of the same action.
     * Currently the only use for this is Shaman Lightning Overload.
     *
     * @generated from protobuf field: int32 tag = 4;
     */
    tag: number;
}
/**
 * @generated from protobuf message proto.Glyphs
 */
export interface Glyphs {
    /**
     * @generated from protobuf field: int32 major1 = 1;
     */
    major1: number;
    /**
     * @generated from protobuf field: int32 major2 = 2;
     */
    major2: number;
    /**
     * @generated from protobuf field: int32 major3 = 3;
     */
    major3: number;
    /**
     * @generated from protobuf field: int32 minor1 = 4;
     */
    minor1: number;
    /**
     * @generated from protobuf field: int32 minor2 = 5;
     */
    minor2: number;
    /**
     * @generated from protobuf field: int32 minor3 = 6;
     */
    minor3: number;
}
/**
 * Custom options for a particular cooldown.
 *
 * @generated from protobuf message proto.Cooldown
 */
export interface Cooldown {
    /**
     * Identifies the cooldown to which these settings will apply.
     *
     * @generated from protobuf field: proto.ActionID id = 1;
     */
    id?: ActionID;
    /**
     * Fixed times at which to use this cooldown. Each value corresponds to a usage,
     * e.g. first value is the first usage, second value is the second usage.
     * Any usages after the specified timings will occur as soon as possible, subject
     * to the ShouldActivate() condition.
     *
     * @generated from protobuf field: repeated double timings = 2;
     */
    timings: number[];
}
/**
 * @generated from protobuf message proto.Cooldowns
 */
export interface Cooldowns {
    /**
     * @generated from protobuf field: repeated proto.Cooldown cooldowns = 1;
     */
    cooldowns: Cooldown[];
    /**
     * % HP threshold, below which defensive cooldowns can be used.
     *
     * @generated from protobuf field: double hp_percent_for_defensives = 2;
     */
    hpPercentForDefensives: number;
    /**
     * @generated from protobuf field: int32 desync_proc_trinket1_seconds = 3;
     */
    desyncProcTrinket1Seconds: number;
    /**
     * @generated from protobuf field: int32 desync_proc_trinket2_seconds = 4;
     */
    desyncProcTrinket2Seconds: number;
}
/**
 * @generated from protobuf message proto.HealingModel
 */
export interface HealingModel {
    /**
     * Healing per second to apply.
     *
     * @generated from protobuf field: double hps = 1;
     */
    hps: number;
    /**
     * How often healing is applied.
     *
     * @generated from protobuf field: double cadence_seconds = 2;
     */
    cadenceSeconds: number;
    /**
     * Variation in the cadence.
     *
     * @generated from protobuf field: double cadence_variation = 5;
     */
    cadenceVariation: number;
    /**
     * % Inspiration buff uptime
     *
     * @generated from protobuf field: double inspiration_uptime = 3;
     */
    inspirationUptime: number;
    /**
     * TMI burst window bin size
     *
     * @generated from protobuf field: int32 burst_window = 4;
     */
    burstWindow: number;
}
/**
 * @generated from protobuf message proto.CustomRotation
 */
export interface CustomRotation {
    /**
     * @generated from protobuf field: repeated proto.CustomSpell spells = 1;
     */
    spells: CustomSpell[];
}
/**
 * @generated from protobuf message proto.CustomSpell
 */
export interface CustomSpell {
    /**
     * This should usually be a spec-specific enum value.
     *
     * @generated from protobuf field: int32 spell = 1;
     */
    spell: number;
    /**
     * Desired cast rate for this spell. Not used by most custom rotations, this is
     * primarily for healers.
     *
     * @generated from protobuf field: double casts_per_minute = 2;
     */
    castsPerMinute: number;
}
/**
 * @generated from protobuf message proto.ItemSwap
 */
export interface ItemSwap {
    /**
     * @generated from protobuf field: proto.ItemSpec mh_item = 1;
     */
    mhItem?: ItemSpec;
    /**
     * @generated from protobuf field: proto.ItemSpec oh_item = 2;
     */
    ohItem?: ItemSpec;
    /**
     * @generated from protobuf field: proto.ItemSpec ranged_item = 3;
     */
    rangedItem?: ItemSpec;
}
/**
 * @generated from protobuf message proto.Duration
 */
export interface Duration {
    /**
     * @generated from protobuf field: double ms = 1;
     */
    ms: number;
}
/**
 * @generated from protobuf enum proto.Spec
 */
export enum Spec {
    /**
     * @generated from protobuf enum value: SpecBalanceDruid = 0;
     */
    SpecBalanceDruid = 0,
    /**
     * @generated from protobuf enum value: SpecFeralDruid = 12;
     */
    SpecFeralDruid = 12,
    /**
     * @generated from protobuf enum value: SpecFeralTankDruid = 14;
     */
    SpecFeralTankDruid = 14,
    /**
     * @generated from protobuf enum value: SpecRestorationDruid = 18;
     */
    SpecRestorationDruid = 18,
    /**
     * @generated from protobuf enum value: SpecElementalShaman = 1;
     */
    SpecElementalShaman = 1,
    /**
     * @generated from protobuf enum value: SpecEnhancementShaman = 9;
     */
    SpecEnhancementShaman = 9,
    /**
     * @generated from protobuf enum value: SpecRestorationShaman = 19;
     */
    SpecRestorationShaman = 19,
    /**
     * @generated from protobuf enum value: SpecHunter = 8;
     */
    SpecHunter = 8,
    /**
     * @generated from protobuf enum value: SpecMage = 2;
     */
    SpecMage = 2,
    /**
     * @generated from protobuf enum value: SpecHolyPaladin = 20;
     */
    SpecHolyPaladin = 20,
    /**
     * @generated from protobuf enum value: SpecProtectionPaladin = 13;
     */
    SpecProtectionPaladin = 13,
    /**
     * @generated from protobuf enum value: SpecRetributionPaladin = 3;
     */
    SpecRetributionPaladin = 3,
    /**
     * @generated from protobuf enum value: SpecRogue = 7;
     */
    SpecRogue = 7,
    /**
     * @generated from protobuf enum value: SpecHealingPriest = 17;
     */
    SpecHealingPriest = 17,
    /**
     * @generated from protobuf enum value: SpecShadowPriest = 4;
     */
    SpecShadowPriest = 4,
    /**
     * @generated from protobuf enum value: SpecSmitePriest = 10;
     */
    SpecSmitePriest = 10,
    /**
     * @generated from protobuf enum value: SpecWarlock = 5;
     */
    SpecWarlock = 5,
    /**
     * @generated from protobuf enum value: SpecWarrior = 6;
     */
    SpecWarrior = 6,
    /**
     * @generated from protobuf enum value: SpecProtectionWarrior = 11;
     */
    SpecProtectionWarrior = 11,
    /**
     * @generated from protobuf enum value: SpecDeathknight = 15;
     */
    SpecDeathknight = 15,
    /**
     * @generated from protobuf enum value: SpecTankDeathknight = 16;
     */
    SpecTankDeathknight = 16
}
/**
 * @generated from protobuf enum proto.Race
 */
export enum Race {
    /**
     * @generated from protobuf enum value: RaceUnknown = 0;
     */
    RaceUnknown = 0,
    /**
     * @generated from protobuf enum value: RaceBloodElf = 1;
     */
    RaceBloodElf = 1,
    /**
     * @generated from protobuf enum value: RaceDraenei = 2;
     */
    RaceDraenei = 2,
    /**
     * @generated from protobuf enum value: RaceDwarf = 3;
     */
    RaceDwarf = 3,
    /**
     * @generated from protobuf enum value: RaceGnome = 4;
     */
    RaceGnome = 4,
    /**
     * @generated from protobuf enum value: RaceHuman = 5;
     */
    RaceHuman = 5,
    /**
     * @generated from protobuf enum value: RaceNightElf = 6;
     */
    RaceNightElf = 6,
    /**
     * @generated from protobuf enum value: RaceOrc = 7;
     */
    RaceOrc = 7,
    /**
     * @generated from protobuf enum value: RaceTauren = 8;
     */
    RaceTauren = 8,
    /**
     * @generated from protobuf enum value: RaceTroll = 9;
     */
    RaceTroll = 9,
    /**
     * @generated from protobuf enum value: RaceUndead = 10;
     */
    RaceUndead = 10
}
/**
 * @generated from protobuf enum proto.Faction
 */
export enum Faction {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    Unknown = 0,
    /**
     * @generated from protobuf enum value: Alliance = 1;
     */
    Alliance = 1,
    /**
     * @generated from protobuf enum value: Horde = 2;
     */
    Horde = 2
}
/**
 * @generated from protobuf enum proto.ShattrathFaction
 */
export enum ShattrathFaction {
    /**
     * @generated from protobuf enum value: None = 0;
     */
    None = 0,
    /**
     * @generated from protobuf enum value: Aldor = 1;
     */
    Aldor = 1,
    /**
     * @generated from protobuf enum value: Scryer = 2;
     */
    Scryer = 2
}
/**
 * @generated from protobuf enum proto.Class
 */
export enum Class {
    /**
     * @generated from protobuf enum value: ClassUnknown = 0;
     */
    ClassUnknown = 0,
    /**
     * @generated from protobuf enum value: ClassDruid = 1;
     */
    ClassDruid = 1,
    /**
     * @generated from protobuf enum value: ClassHunter = 2;
     */
    ClassHunter = 2,
    /**
     * @generated from protobuf enum value: ClassMage = 3;
     */
    ClassMage = 3,
    /**
     * @generated from protobuf enum value: ClassPaladin = 4;
     */
    ClassPaladin = 4,
    /**
     * @generated from protobuf enum value: ClassPriest = 5;
     */
    ClassPriest = 5,
    /**
     * @generated from protobuf enum value: ClassRogue = 6;
     */
    ClassRogue = 6,
    /**
     * @generated from protobuf enum value: ClassShaman = 7;
     */
    ClassShaman = 7,
    /**
     * @generated from protobuf enum value: ClassWarlock = 8;
     */
    ClassWarlock = 8,
    /**
     * @generated from protobuf enum value: ClassWarrior = 9;
     */
    ClassWarrior = 9,
    /**
     * @generated from protobuf enum value: ClassDeathknight = 10;
     */
    ClassDeathknight = 10
}
/**
 * @generated from protobuf enum proto.Profession
 */
export enum Profession {
    /**
     * @generated from protobuf enum value: ProfessionUnknown = 0;
     */
    ProfessionUnknown = 0,
    /**
     * @generated from protobuf enum value: Alchemy = 1;
     */
    Alchemy = 1,
    /**
     * @generated from protobuf enum value: Blacksmithing = 2;
     */
    Blacksmithing = 2,
    /**
     * @generated from protobuf enum value: Enchanting = 3;
     */
    Enchanting = 3,
    /**
     * @generated from protobuf enum value: Engineering = 4;
     */
    Engineering = 4,
    /**
     * @generated from protobuf enum value: Herbalism = 5;
     */
    Herbalism = 5,
    /**
     * @generated from protobuf enum value: Inscription = 6;
     */
    Inscription = 6,
    /**
     * @generated from protobuf enum value: Jewelcrafting = 7;
     */
    Jewelcrafting = 7,
    /**
     * @generated from protobuf enum value: Leatherworking = 8;
     */
    Leatherworking = 8,
    /**
     * @generated from protobuf enum value: Mining = 9;
     */
    Mining = 9,
    /**
     * @generated from protobuf enum value: Skinning = 10;
     */
    Skinning = 10,
    /**
     * @generated from protobuf enum value: Tailoring = 11;
     */
    Tailoring = 11
}
/**
 * Keep in sync with sim/core/stats/stats.go.
 *
 * @generated from protobuf enum proto.Stat
 */
export enum Stat {
    /**
     * @generated from protobuf enum value: StatStrength = 0;
     */
    StatStrength = 0,
    /**
     * @generated from protobuf enum value: StatAgility = 1;
     */
    StatAgility = 1,
    /**
     * @generated from protobuf enum value: StatStamina = 2;
     */
    StatStamina = 2,
    /**
     * @generated from protobuf enum value: StatIntellect = 3;
     */
    StatIntellect = 3,
    /**
     * @generated from protobuf enum value: StatSpirit = 4;
     */
    StatSpirit = 4,
    /**
     * @generated from protobuf enum value: StatSpellPower = 5;
     */
    StatSpellPower = 5,
    /**
     * @generated from protobuf enum value: StatMP5 = 6;
     */
    StatMP5 = 6,
    /**
     * @generated from protobuf enum value: StatSpellHit = 7;
     */
    StatSpellHit = 7,
    /**
     * @generated from protobuf enum value: StatSpellCrit = 8;
     */
    StatSpellCrit = 8,
    /**
     * @generated from protobuf enum value: StatSpellHaste = 9;
     */
    StatSpellHaste = 9,
    /**
     * @generated from protobuf enum value: StatSpellPenetration = 10;
     */
    StatSpellPenetration = 10,
    /**
     * @generated from protobuf enum value: StatAttackPower = 11;
     */
    StatAttackPower = 11,
    /**
     * @generated from protobuf enum value: StatMeleeHit = 12;
     */
    StatMeleeHit = 12,
    /**
     * @generated from protobuf enum value: StatMeleeCrit = 13;
     */
    StatMeleeCrit = 13,
    /**
     * @generated from protobuf enum value: StatMeleeHaste = 14;
     */
    StatMeleeHaste = 14,
    /**
     * @generated from protobuf enum value: StatArmorPenetration = 15;
     */
    StatArmorPenetration = 15,
    /**
     * @generated from protobuf enum value: StatExpertise = 16;
     */
    StatExpertise = 16,
    /**
     * @generated from protobuf enum value: StatMana = 17;
     */
    StatMana = 17,
    /**
     * @generated from protobuf enum value: StatEnergy = 18;
     */
    StatEnergy = 18,
    /**
     * @generated from protobuf enum value: StatRage = 19;
     */
    StatRage = 19,
    /**
     * @generated from protobuf enum value: StatArmor = 20;
     */
    StatArmor = 20,
    /**
     * @generated from protobuf enum value: StatRangedAttackPower = 21;
     */
    StatRangedAttackPower = 21,
    /**
     * @generated from protobuf enum value: StatDefense = 22;
     */
    StatDefense = 22,
    /**
     * @generated from protobuf enum value: StatBlock = 23;
     */
    StatBlock = 23,
    /**
     * @generated from protobuf enum value: StatBlockValue = 24;
     */
    StatBlockValue = 24,
    /**
     * @generated from protobuf enum value: StatDodge = 25;
     */
    StatDodge = 25,
    /**
     * @generated from protobuf enum value: StatParry = 26;
     */
    StatParry = 26,
    /**
     * @generated from protobuf enum value: StatResilience = 27;
     */
    StatResilience = 27,
    /**
     * @generated from protobuf enum value: StatHealth = 28;
     */
    StatHealth = 28,
    /**
     * @generated from protobuf enum value: StatArcaneResistance = 29;
     */
    StatArcaneResistance = 29,
    /**
     * @generated from protobuf enum value: StatFireResistance = 30;
     */
    StatFireResistance = 30,
    /**
     * @generated from protobuf enum value: StatFrostResistance = 31;
     */
    StatFrostResistance = 31,
    /**
     * @generated from protobuf enum value: StatNatureResistance = 32;
     */
    StatNatureResistance = 32,
    /**
     * @generated from protobuf enum value: StatShadowResistance = 33;
     */
    StatShadowResistance = 33,
    /**
     * @generated from protobuf enum value: StatBonusArmor = 34;
     */
    StatBonusArmor = 34,
    /**
     * Placeholder: not used yet.
     *
     * @generated from protobuf enum value: StatRunicPower = 35;
     */
    StatRunicPower = 35,
    /**
     * Placeholder: not used yet.
     *
     * @generated from protobuf enum value: StatBloodRune = 36;
     */
    StatBloodRune = 36,
    /**
     * Placeholder: not used yet.
     *
     * @generated from protobuf enum value: StatFrostRune = 37;
     */
    StatFrostRune = 37,
    /**
     * Placeholder: not used yet.
     *
     * @generated from protobuf enum value: StatUnholyRune = 38;
     */
    StatUnholyRune = 38,
    /**
     * Placeholder: not used yet.
     *
     * @generated from protobuf enum value: StatDeathRune = 39;
     */
    StatDeathRune = 39
}
/**
 * Not all pseudostats are included here; just the ones we want to pass
 * between the UI and backend.
 *
 * It's also OK to include things here which aren't in the PseudoStats struct.
 *
 * @generated from protobuf enum proto.PseudoStat
 */
export enum PseudoStat {
    /**
     * @generated from protobuf enum value: PseudoStatMainHandDps = 0;
     */
    PseudoStatMainHandDps = 0,
    /**
     * @generated from protobuf enum value: PseudoStatOffHandDps = 1;
     */
    PseudoStatOffHandDps = 1,
    /**
     * @generated from protobuf enum value: PseudoStatRangedDps = 2;
     */
    PseudoStatRangedDps = 2,
    /**
     * @generated from protobuf enum value: PseudoStatBlockValueMultiplier = 3;
     */
    PseudoStatBlockValueMultiplier = 3,
    /**
     * @generated from protobuf enum value: PseudoStatDodge = 4;
     */
    PseudoStatDodge = 4,
    /**
     * @generated from protobuf enum value: PseudoStatParry = 5;
     */
    PseudoStatParry = 5
}
/**
 * @generated from protobuf enum proto.ItemType
 */
export enum ItemType {
    /**
     * @generated from protobuf enum value: ItemTypeUnknown = 0;
     */
    ItemTypeUnknown = 0,
    /**
     * @generated from protobuf enum value: ItemTypeHead = 1;
     */
    ItemTypeHead = 1,
    /**
     * @generated from protobuf enum value: ItemTypeNeck = 2;
     */
    ItemTypeNeck = 2,
    /**
     * @generated from protobuf enum value: ItemTypeShoulder = 3;
     */
    ItemTypeShoulder = 3,
    /**
     * @generated from protobuf enum value: ItemTypeBack = 4;
     */
    ItemTypeBack = 4,
    /**
     * @generated from protobuf enum value: ItemTypeChest = 5;
     */
    ItemTypeChest = 5,
    /**
     * @generated from protobuf enum value: ItemTypeWrist = 6;
     */
    ItemTypeWrist = 6,
    /**
     * @generated from protobuf enum value: ItemTypeHands = 7;
     */
    ItemTypeHands = 7,
    /**
     * @generated from protobuf enum value: ItemTypeWaist = 8;
     */
    ItemTypeWaist = 8,
    /**
     * @generated from protobuf enum value: ItemTypeLegs = 9;
     */
    ItemTypeLegs = 9,
    /**
     * @generated from protobuf enum value: ItemTypeFeet = 10;
     */
    ItemTypeFeet = 10,
    /**
     * @generated from protobuf enum value: ItemTypeFinger = 11;
     */
    ItemTypeFinger = 11,
    /**
     * @generated from protobuf enum value: ItemTypeTrinket = 12;
     */
    ItemTypeTrinket = 12,
    /**
     * @generated from protobuf enum value: ItemTypeWeapon = 13;
     */
    ItemTypeWeapon = 13,
    /**
     * @generated from protobuf enum value: ItemTypeRanged = 14;
     */
    ItemTypeRanged = 14
}
/**
 * @generated from protobuf enum proto.ArmorType
 */
export enum ArmorType {
    /**
     * @generated from protobuf enum value: ArmorTypeUnknown = 0;
     */
    ArmorTypeUnknown = 0,
    /**
     * @generated from protobuf enum value: ArmorTypeCloth = 1;
     */
    ArmorTypeCloth = 1,
    /**
     * @generated from protobuf enum value: ArmorTypeLeather = 2;
     */
    ArmorTypeLeather = 2,
    /**
     * @generated from protobuf enum value: ArmorTypeMail = 3;
     */
    ArmorTypeMail = 3,
    /**
     * @generated from protobuf enum value: ArmorTypePlate = 4;
     */
    ArmorTypePlate = 4
}
/**
 * @generated from protobuf enum proto.WeaponType
 */
export enum WeaponType {
    /**
     * @generated from protobuf enum value: WeaponTypeUnknown = 0;
     */
    WeaponTypeUnknown = 0,
    /**
     * @generated from protobuf enum value: WeaponTypeAxe = 1;
     */
    WeaponTypeAxe = 1,
    /**
     * @generated from protobuf enum value: WeaponTypeDagger = 2;
     */
    WeaponTypeDagger = 2,
    /**
     * @generated from protobuf enum value: WeaponTypeFist = 3;
     */
    WeaponTypeFist = 3,
    /**
     * @generated from protobuf enum value: WeaponTypeMace = 4;
     */
    WeaponTypeMace = 4,
    /**
     * @generated from protobuf enum value: WeaponTypeOffHand = 5;
     */
    WeaponTypeOffHand = 5,
    /**
     * @generated from protobuf enum value: WeaponTypePolearm = 6;
     */
    WeaponTypePolearm = 6,
    /**
     * @generated from protobuf enum value: WeaponTypeShield = 7;
     */
    WeaponTypeShield = 7,
    /**
     * @generated from protobuf enum value: WeaponTypeStaff = 8;
     */
    WeaponTypeStaff = 8,
    /**
     * @generated from protobuf enum value: WeaponTypeSword = 9;
     */
    WeaponTypeSword = 9
}
/**
 * @generated from protobuf enum proto.HandType
 */
export enum HandType {
    /**
     * @generated from protobuf enum value: HandTypeUnknown = 0;
     */
    HandTypeUnknown = 0,
    /**
     * @generated from protobuf enum value: HandTypeMainHand = 1;
     */
    HandTypeMainHand = 1,
    /**
     * @generated from protobuf enum value: HandTypeOneHand = 2;
     */
    HandTypeOneHand = 2,
    /**
     * @generated from protobuf enum value: HandTypeOffHand = 3;
     */
    HandTypeOffHand = 3,
    /**
     * @generated from protobuf enum value: HandTypeTwoHand = 4;
     */
    HandTypeTwoHand = 4
}
/**
 * @generated from protobuf enum proto.RangedWeaponType
 */
export enum RangedWeaponType {
    /**
     * @generated from protobuf enum value: RangedWeaponTypeUnknown = 0;
     */
    RangedWeaponTypeUnknown = 0,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeBow = 1;
     */
    RangedWeaponTypeBow = 1,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeCrossbow = 2;
     */
    RangedWeaponTypeCrossbow = 2,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeGun = 3;
     */
    RangedWeaponTypeGun = 3,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeIdol = 4;
     */
    RangedWeaponTypeIdol = 4,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeLibram = 5;
     */
    RangedWeaponTypeLibram = 5,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeThrown = 6;
     */
    RangedWeaponTypeThrown = 6,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeTotem = 7;
     */
    RangedWeaponTypeTotem = 7,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeWand = 8;
     */
    RangedWeaponTypeWand = 8,
    /**
     * @generated from protobuf enum value: RangedWeaponTypeSigil = 9;
     */
    RangedWeaponTypeSigil = 9
}
/**
 * All slots on the gear menu where a single item can be worn.
 *
 * @generated from protobuf enum proto.ItemSlot
 */
export enum ItemSlot {
    /**
     * @generated from protobuf enum value: ItemSlotHead = 0;
     */
    ItemSlotHead = 0,
    /**
     * @generated from protobuf enum value: ItemSlotNeck = 1;
     */
    ItemSlotNeck = 1,
    /**
     * @generated from protobuf enum value: ItemSlotShoulder = 2;
     */
    ItemSlotShoulder = 2,
    /**
     * @generated from protobuf enum value: ItemSlotBack = 3;
     */
    ItemSlotBack = 3,
    /**
     * @generated from protobuf enum value: ItemSlotChest = 4;
     */
    ItemSlotChest = 4,
    /**
     * @generated from protobuf enum value: ItemSlotWrist = 5;
     */
    ItemSlotWrist = 5,
    /**
     * @generated from protobuf enum value: ItemSlotHands = 6;
     */
    ItemSlotHands = 6,
    /**
     * @generated from protobuf enum value: ItemSlotWaist = 7;
     */
    ItemSlotWaist = 7,
    /**
     * @generated from protobuf enum value: ItemSlotLegs = 8;
     */
    ItemSlotLegs = 8,
    /**
     * @generated from protobuf enum value: ItemSlotFeet = 9;
     */
    ItemSlotFeet = 9,
    /**
     * @generated from protobuf enum value: ItemSlotFinger1 = 10;
     */
    ItemSlotFinger1 = 10,
    /**
     * @generated from protobuf enum value: ItemSlotFinger2 = 11;
     */
    ItemSlotFinger2 = 11,
    /**
     * @generated from protobuf enum value: ItemSlotTrinket1 = 12;
     */
    ItemSlotTrinket1 = 12,
    /**
     * @generated from protobuf enum value: ItemSlotTrinket2 = 13;
     */
    ItemSlotTrinket2 = 13,
    /**
     * can be 1h or 2h
     *
     * @generated from protobuf enum value: ItemSlotMainHand = 14;
     */
    ItemSlotMainHand = 14,
    /**
     * @generated from protobuf enum value: ItemSlotOffHand = 15;
     */
    ItemSlotOffHand = 15,
    /**
     * @generated from protobuf enum value: ItemSlotRanged = 16;
     */
    ItemSlotRanged = 16
}
/**
 * @generated from protobuf enum proto.ItemQuality
 */
export enum ItemQuality {
    /**
     * @generated from protobuf enum value: ItemQualityJunk = 0;
     */
    ItemQualityJunk = 0,
    /**
     * @generated from protobuf enum value: ItemQualityCommon = 1;
     */
    ItemQualityCommon = 1,
    /**
     * @generated from protobuf enum value: ItemQualityUncommon = 2;
     */
    ItemQualityUncommon = 2,
    /**
     * @generated from protobuf enum value: ItemQualityRare = 3;
     */
    ItemQualityRare = 3,
    /**
     * @generated from protobuf enum value: ItemQualityEpic = 4;
     */
    ItemQualityEpic = 4,
    /**
     * @generated from protobuf enum value: ItemQualityLegendary = 5;
     */
    ItemQualityLegendary = 5,
    /**
     * @generated from protobuf enum value: ItemQualityArtifact = 6;
     */
    ItemQualityArtifact = 6,
    /**
     * @generated from protobuf enum value: ItemQualityHeirloom = 7;
     */
    ItemQualityHeirloom = 7
}
/**
 * @generated from protobuf enum proto.GemColor
 */
export enum GemColor {
    /**
     * @generated from protobuf enum value: GemColorUnknown = 0;
     */
    GemColorUnknown = 0,
    /**
     * @generated from protobuf enum value: GemColorMeta = 1;
     */
    GemColorMeta = 1,
    /**
     * @generated from protobuf enum value: GemColorRed = 2;
     */
    GemColorRed = 2,
    /**
     * @generated from protobuf enum value: GemColorBlue = 3;
     */
    GemColorBlue = 3,
    /**
     * @generated from protobuf enum value: GemColorYellow = 4;
     */
    GemColorYellow = 4,
    /**
     * @generated from protobuf enum value: GemColorGreen = 5;
     */
    GemColorGreen = 5,
    /**
     * @generated from protobuf enum value: GemColorOrange = 6;
     */
    GemColorOrange = 6,
    /**
     * @generated from protobuf enum value: GemColorPurple = 7;
     */
    GemColorPurple = 7,
    /**
     * @generated from protobuf enum value: GemColorPrismatic = 8;
     */
    GemColorPrismatic = 8
}
/**
 * @generated from protobuf enum proto.SpellSchool
 */
export enum SpellSchool {
    /**
     * @generated from protobuf enum value: SpellSchoolPhysical = 0;
     */
    SpellSchoolPhysical = 0,
    /**
     * @generated from protobuf enum value: SpellSchoolArcane = 1;
     */
    SpellSchoolArcane = 1,
    /**
     * @generated from protobuf enum value: SpellSchoolFire = 2;
     */
    SpellSchoolFire = 2,
    /**
     * @generated from protobuf enum value: SpellSchoolFrost = 3;
     */
    SpellSchoolFrost = 3,
    /**
     * @generated from protobuf enum value: SpellSchoolHoly = 4;
     */
    SpellSchoolHoly = 4,
    /**
     * @generated from protobuf enum value: SpellSchoolNature = 5;
     */
    SpellSchoolNature = 5,
    /**
     * @generated from protobuf enum value: SpellSchoolShadow = 6;
     */
    SpellSchoolShadow = 6
}
/**
 * @generated from protobuf enum proto.TristateEffect
 */
export enum TristateEffect {
    /**
     * @generated from protobuf enum value: TristateEffectMissing = 0;
     */
    TristateEffectMissing = 0,
    /**
     * @generated from protobuf enum value: TristateEffectRegular = 1;
     */
    TristateEffectRegular = 1,
    /**
     * @generated from protobuf enum value: TristateEffectImproved = 2;
     */
    TristateEffectImproved = 2
}
/**
 * @generated from protobuf enum proto.Explosive
 */
export enum Explosive {
    /**
     * @generated from protobuf enum value: ExplosiveUnknown = 0;
     */
    ExplosiveUnknown = 0,
    /**
     * @generated from protobuf enum value: ExplosiveSaroniteBomb = 1;
     */
    ExplosiveSaroniteBomb = 1,
    /**
     * @generated from protobuf enum value: ExplosiveCobaltFragBomb = 2;
     */
    ExplosiveCobaltFragBomb = 2,
    /**
     * @generated from protobuf enum value: ExplosiveBiggerOne = 3;
     */
    ExplosiveBiggerOne = 3,
    /**
     * @generated from protobuf enum value: ExplosiveAdamantiteGrenade = 4;
     */
    ExplosiveAdamantiteGrenade = 4,
    /**
     * @generated from protobuf enum value: ExplosiveFelIronBomb = 5;
     */
    ExplosiveFelIronBomb = 5
}
/**
 * @generated from protobuf enum proto.Potions
 */
export enum Potions {
    /**
     * @generated from protobuf enum value: UnknownPotion = 0;
     */
    UnknownPotion = 0,
    /**
     * @generated from protobuf enum value: RunicHealingPotion = 1;
     */
    RunicHealingPotion = 1,
    /**
     * @generated from protobuf enum value: RunicManaPotion = 2;
     */
    RunicManaPotion = 2,
    /**
     * @generated from protobuf enum value: IndestructiblePotion = 3;
     */
    IndestructiblePotion = 3,
    /**
     * @generated from protobuf enum value: PotionOfSpeed = 4;
     */
    PotionOfSpeed = 4,
    /**
     * @generated from protobuf enum value: PotionOfWildMagic = 5;
     */
    PotionOfWildMagic = 5,
    /**
     * @generated from protobuf enum value: DestructionPotion = 6;
     */
    DestructionPotion = 6,
    /**
     * @generated from protobuf enum value: SuperManaPotion = 7;
     */
    SuperManaPotion = 7,
    /**
     * @generated from protobuf enum value: HastePotion = 8;
     */
    HastePotion = 8,
    /**
     * @generated from protobuf enum value: MightyRagePotion = 9;
     */
    MightyRagePotion = 9,
    /**
     * @generated from protobuf enum value: FelManaPotion = 10;
     */
    FelManaPotion = 10,
    /**
     * @generated from protobuf enum value: InsaneStrengthPotion = 11;
     */
    InsaneStrengthPotion = 11,
    /**
     * @generated from protobuf enum value: IronshieldPotion = 12;
     */
    IronshieldPotion = 12,
    /**
     * @generated from protobuf enum value: HeroicPotion = 13;
     */
    HeroicPotion = 13,
    /**
     * @generated from protobuf enum value: RunicManaInjector = 14;
     */
    RunicManaInjector = 14,
    /**
     * @generated from protobuf enum value: RunicHealingInjector = 15;
     */
    RunicHealingInjector = 15
}
/**
 * @generated from protobuf enum proto.Conjured
 */
export enum Conjured {
    /**
     * @generated from protobuf enum value: ConjuredUnknown = 0;
     */
    ConjuredUnknown = 0,
    /**
     * @generated from protobuf enum value: ConjuredDarkRune = 1;
     */
    ConjuredDarkRune = 1,
    /**
     * @generated from protobuf enum value: ConjuredFlameCap = 2;
     */
    ConjuredFlameCap = 2,
    /**
     * @generated from protobuf enum value: ConjuredHealthstone = 5;
     */
    ConjuredHealthstone = 5,
    /**
     * @generated from protobuf enum value: ConjuredRogueThistleTea = 4;
     */
    ConjuredRogueThistleTea = 4
}
/**
 * @generated from protobuf enum proto.WeaponImbue
 */
export enum WeaponImbue {
    /**
     * @generated from protobuf enum value: ImbueUnknown = 0;
     */
    ImbueUnknown = 0,
    /**
     * @generated from protobuf enum value: ImbueBrilliantWizardOil = 1;
     */
    ImbueBrilliantWizardOil = 1,
    /**
     * @generated from protobuf enum value: ImbueBrilliantManaOil = 2;
     */
    ImbueBrilliantManaOil = 2,
    /**
     * @generated from protobuf enum value: ImbueSuperiorWizardOil = 3;
     */
    ImbueSuperiorWizardOil = 3,
    /**
     * @generated from protobuf enum value: ImbueSuperiorManaOil = 4;
     */
    ImbueSuperiorManaOil = 4,
    /**
     * @generated from protobuf enum value: ImbueAdamantiteSharpeningStone = 5;
     */
    ImbueAdamantiteSharpeningStone = 5,
    /**
     * @generated from protobuf enum value: ImbueAdamantiteWeightStone = 6;
     */
    ImbueAdamantiteWeightStone = 6,
    /**
     * @generated from protobuf enum value: ImbueElementalSharpeningStone = 7;
     */
    ImbueElementalSharpeningStone = 7,
    /**
     * @generated from protobuf enum value: ImbueFireStone = 8;
     */
    ImbueFireStone = 8,
    /**
     * @generated from protobuf enum value: ImbueSpellStone = 9;
     */
    ImbueSpellStone = 9
}
/**
 * @generated from protobuf enum proto.Flask
 */
export enum Flask {
    /**
     * @generated from protobuf enum value: FlaskUnknown = 0;
     */
    FlaskUnknown = 0,
    /**
     * @generated from protobuf enum value: FlaskOfTheFrostWyrm = 1;
     */
    FlaskOfTheFrostWyrm = 1,
    /**
     * @generated from protobuf enum value: FlaskOfEndlessRage = 2;
     */
    FlaskOfEndlessRage = 2,
    /**
     * @generated from protobuf enum value: FlaskOfPureMojo = 3;
     */
    FlaskOfPureMojo = 3,
    /**
     * @generated from protobuf enum value: FlaskOfStoneblood = 4;
     */
    FlaskOfStoneblood = 4,
    /**
     * @generated from protobuf enum value: LesserFlaskOfToughness = 5;
     */
    LesserFlaskOfToughness = 5,
    /**
     * @generated from protobuf enum value: LesserFlaskOfResistance = 6;
     */
    LesserFlaskOfResistance = 6,
    /**
     * TBC
     *
     * @generated from protobuf enum value: FlaskOfBlindingLight = 7;
     */
    FlaskOfBlindingLight = 7,
    /**
     * @generated from protobuf enum value: FlaskOfMightyRestoration = 8;
     */
    FlaskOfMightyRestoration = 8,
    /**
     * @generated from protobuf enum value: FlaskOfPureDeath = 9;
     */
    FlaskOfPureDeath = 9,
    /**
     * @generated from protobuf enum value: FlaskOfRelentlessAssault = 10;
     */
    FlaskOfRelentlessAssault = 10,
    /**
     * @generated from protobuf enum value: FlaskOfSupremePower = 11;
     */
    FlaskOfSupremePower = 11,
    /**
     * @generated from protobuf enum value: FlaskOfFortification = 12;
     */
    FlaskOfFortification = 12,
    /**
     * @generated from protobuf enum value: FlaskOfChromaticWonder = 13;
     */
    FlaskOfChromaticWonder = 13,
    /**
     * @generated from protobuf enum value: FlaskOfDistilledWisdom = 14;
     */
    FlaskOfDistilledWisdom = 14
}
/**
 * @generated from protobuf enum proto.BattleElixir
 */
export enum BattleElixir {
    /**
     * @generated from protobuf enum value: BattleElixirUnknown = 0;
     */
    BattleElixirUnknown = 0,
    /**
     * @generated from protobuf enum value: ElixirOfAccuracy = 1;
     */
    ElixirOfAccuracy = 1,
    /**
     * @generated from protobuf enum value: ElixirOfArmorPiercing = 2;
     */
    ElixirOfArmorPiercing = 2,
    /**
     * @generated from protobuf enum value: ElixirOfDeadlyStrikes = 3;
     */
    ElixirOfDeadlyStrikes = 3,
    /**
     * @generated from protobuf enum value: ElixirOfExpertise = 4;
     */
    ElixirOfExpertise = 4,
    /**
     * @generated from protobuf enum value: ElixirOfLightningSpeed = 5;
     */
    ElixirOfLightningSpeed = 5,
    /**
     * @generated from protobuf enum value: ElixirOfMightyAgility = 6;
     */
    ElixirOfMightyAgility = 6,
    /**
     * @generated from protobuf enum value: ElixirOfMightyStrength = 7;
     */
    ElixirOfMightyStrength = 7,
    /**
     * @generated from protobuf enum value: GurusElixir = 8;
     */
    GurusElixir = 8,
    /**
     * @generated from protobuf enum value: SpellpowerElixir = 9;
     */
    SpellpowerElixir = 9,
    /**
     * @generated from protobuf enum value: WrathElixir = 10;
     */
    WrathElixir = 10,
    /**
     * TBC
     *
     * @generated from protobuf enum value: AdeptsElixir = 11;
     */
    AdeptsElixir = 11,
    /**
     * @generated from protobuf enum value: ElixirOfDemonslaying = 12;
     */
    ElixirOfDemonslaying = 12,
    /**
     * @generated from protobuf enum value: ElixirOfMajorAgility = 13;
     */
    ElixirOfMajorAgility = 13,
    /**
     * @generated from protobuf enum value: ElixirOfMajorFirePower = 14;
     */
    ElixirOfMajorFirePower = 14,
    /**
     * @generated from protobuf enum value: ElixirOfMajorFrostPower = 15;
     */
    ElixirOfMajorFrostPower = 15,
    /**
     * @generated from protobuf enum value: ElixirOfMajorShadowPower = 16;
     */
    ElixirOfMajorShadowPower = 16,
    /**
     * @generated from protobuf enum value: ElixirOfMajorStrength = 17;
     */
    ElixirOfMajorStrength = 17,
    /**
     * @generated from protobuf enum value: ElixirOfMastery = 18;
     */
    ElixirOfMastery = 18,
    /**
     * @generated from protobuf enum value: ElixirOfTheMongoose = 19;
     */
    ElixirOfTheMongoose = 19,
    /**
     * @generated from protobuf enum value: FelStrengthElixir = 20;
     */
    FelStrengthElixir = 20,
    /**
     * @generated from protobuf enum value: GreaterArcaneElixir = 21;
     */
    GreaterArcaneElixir = 21,
    /**
     * @generated from protobuf enum value: ElixirOfHealingPower = 22;
     */
    ElixirOfHealingPower = 22
}
/**
 * @generated from protobuf enum proto.GuardianElixir
 */
export enum GuardianElixir {
    /**
     * @generated from protobuf enum value: GuardianElixirUnknown = 0;
     */
    GuardianElixirUnknown = 0,
    /**
     * @generated from protobuf enum value: ElixirOfMightyDefense = 1;
     */
    ElixirOfMightyDefense = 1,
    /**
     * @generated from protobuf enum value: ElixirOfMightyFortitude = 2;
     */
    ElixirOfMightyFortitude = 2,
    /**
     * @generated from protobuf enum value: ElixirOfMightyMageblood = 3;
     */
    ElixirOfMightyMageblood = 3,
    /**
     * @generated from protobuf enum value: ElixirOfMightyThoughts = 4;
     */
    ElixirOfMightyThoughts = 4,
    /**
     * @generated from protobuf enum value: ElixirOfProtection = 5;
     */
    ElixirOfProtection = 5,
    /**
     * @generated from protobuf enum value: ElixirOfSpirit = 6;
     */
    ElixirOfSpirit = 6,
    /**
     * TBC
     *
     * @generated from protobuf enum value: GiftOfArthas = 7;
     */
    GiftOfArthas = 7,
    /**
     * @generated from protobuf enum value: ElixirOfDraenicWisdom = 8;
     */
    ElixirOfDraenicWisdom = 8,
    /**
     * @generated from protobuf enum value: ElixirOfIronskin = 9;
     */
    ElixirOfIronskin = 9,
    /**
     * @generated from protobuf enum value: ElixirOfMajorDefense = 10;
     */
    ElixirOfMajorDefense = 10,
    /**
     * @generated from protobuf enum value: ElixirOfMajorFortitude = 11;
     */
    ElixirOfMajorFortitude = 11,
    /**
     * @generated from protobuf enum value: ElixirOfMajorMageblood = 12;
     */
    ElixirOfMajorMageblood = 12
}
/**
 * @generated from protobuf enum proto.Food
 */
export enum Food {
    /**
     * @generated from protobuf enum value: FoodUnknown = 0;
     */
    FoodUnknown = 0,
    /**
     * @generated from protobuf enum value: FoodFishFeast = 1;
     */
    FoodFishFeast = 1,
    /**
     * @generated from protobuf enum value: FoodGreatFeast = 2;
     */
    FoodGreatFeast = 2,
    /**
     * @generated from protobuf enum value: FoodBlackenedDragonfin = 3;
     */
    FoodBlackenedDragonfin = 3,
    /**
     * @generated from protobuf enum value: FoodHeartyRhino = 4;
     */
    FoodHeartyRhino = 4,
    /**
     * @generated from protobuf enum value: FoodMegaMammothMeal = 5;
     */
    FoodMegaMammothMeal = 5,
    /**
     * @generated from protobuf enum value: FoodSpicedWormBurger = 6;
     */
    FoodSpicedWormBurger = 6,
    /**
     * @generated from protobuf enum value: FoodRhinoliciousWormsteak = 7;
     */
    FoodRhinoliciousWormsteak = 7,
    /**
     * @generated from protobuf enum value: FoodImperialMantaSteak = 8;
     */
    FoodImperialMantaSteak = 8,
    /**
     * @generated from protobuf enum value: FoodSnapperExtreme = 9;
     */
    FoodSnapperExtreme = 9,
    /**
     * @generated from protobuf enum value: FoodMightyRhinoDogs = 10;
     */
    FoodMightyRhinoDogs = 10,
    /**
     * @generated from protobuf enum value: FoodFirecrackerSalmon = 11;
     */
    FoodFirecrackerSalmon = 11,
    /**
     * @generated from protobuf enum value: FoodCuttlesteak = 12;
     */
    FoodCuttlesteak = 12,
    /**
     * @generated from protobuf enum value: FoodDragonfinFilet = 13;
     */
    FoodDragonfinFilet = 13,
    /**
     * TBC Foods
     *
     * @generated from protobuf enum value: FoodBlackenedBasilisk = 14;
     */
    FoodBlackenedBasilisk = 14,
    /**
     * @generated from protobuf enum value: FoodGrilledMudfish = 15;
     */
    FoodGrilledMudfish = 15,
    /**
     * @generated from protobuf enum value: FoodRavagerDog = 16;
     */
    FoodRavagerDog = 16,
    /**
     * @generated from protobuf enum value: FoodRoastedClefthoof = 17;
     */
    FoodRoastedClefthoof = 17,
    /**
     * @generated from protobuf enum value: FoodSkullfishSoup = 18;
     */
    FoodSkullfishSoup = 18,
    /**
     * @generated from protobuf enum value: FoodSpicyHotTalbuk = 19;
     */
    FoodSpicyHotTalbuk = 19,
    /**
     * @generated from protobuf enum value: FoodFishermansFeast = 20;
     */
    FoodFishermansFeast = 20
}
/**
 * @generated from protobuf enum proto.PetFood
 */
export enum PetFood {
    /**
     * @generated from protobuf enum value: PetFoodUnknown = 0;
     */
    PetFoodUnknown = 0,
    /**
     * @generated from protobuf enum value: PetFoodSpicedMammothTreats = 1;
     */
    PetFoodSpicedMammothTreats = 1,
    /**
     * TBC
     *
     * @generated from protobuf enum value: PetFoodKiblersBits = 2;
     */
    PetFoodKiblersBits = 2
}
/**
 * @generated from protobuf enum proto.MobType
 */
export enum MobType {
    /**
     * @generated from protobuf enum value: MobTypeUnknown = 0;
     */
    MobTypeUnknown = 0,
    /**
     * @generated from protobuf enum value: MobTypeBeast = 1;
     */
    MobTypeBeast = 1,
    /**
     * @generated from protobuf enum value: MobTypeDemon = 2;
     */
    MobTypeDemon = 2,
    /**
     * @generated from protobuf enum value: MobTypeDragonkin = 3;
     */
    MobTypeDragonkin = 3,
    /**
     * @generated from protobuf enum value: MobTypeElemental = 4;
     */
    MobTypeElemental = 4,
    /**
     * @generated from protobuf enum value: MobTypeGiant = 5;
     */
    MobTypeGiant = 5,
    /**
     * @generated from protobuf enum value: MobTypeHumanoid = 6;
     */
    MobTypeHumanoid = 6,
    /**
     * @generated from protobuf enum value: MobTypeMechanical = 7;
     */
    MobTypeMechanical = 7,
    /**
     * @generated from protobuf enum value: MobTypeUndead = 8;
     */
    MobTypeUndead = 8
}
/**
 * @generated from protobuf enum proto.InputType
 */
export enum InputType {
    /**
     * @generated from protobuf enum value: Bool = 0;
     */
    Bool = 0,
    /**
     * @generated from protobuf enum value: Number = 1;
     */
    Number = 1
}
/**
 * Extra enum for describing which items are eligible for an enchant, when
 * ItemType alone is not enough.
 *
 * @generated from protobuf enum proto.EnchantType
 */
export enum EnchantType {
    /**
     * @generated from protobuf enum value: EnchantTypeNormal = 0;
     */
    EnchantTypeNormal = 0,
    /**
     * @generated from protobuf enum value: EnchantTypeTwoHand = 1;
     */
    EnchantTypeTwoHand = 1,
    /**
     * @generated from protobuf enum value: EnchantTypeShield = 2;
     */
    EnchantTypeShield = 2,
    /**
     * @generated from protobuf enum value: EnchantTypeKit = 3;
     */
    EnchantTypeKit = 3,
    /**
     * @generated from protobuf enum value: EnchantTypeStaff = 4;
     */
    EnchantTypeStaff = 4
}
/**
 * ID for actions that aren't spells or items.
 *
 * @generated from protobuf enum proto.OtherAction
 */
export enum OtherAction {
    /**
     * @generated from protobuf enum value: OtherActionNone = 0;
     */
    OtherActionNone = 0,
    /**
     * @generated from protobuf enum value: OtherActionWait = 1;
     */
    OtherActionWait = 1,
    /**
     * @generated from protobuf enum value: OtherActionManaRegen = 2;
     */
    OtherActionManaRegen = 2,
    /**
     * @generated from protobuf enum value: OtherActionEnergyRegen = 5;
     */
    OtherActionEnergyRegen = 5,
    /**
     * @generated from protobuf enum value: OtherActionFocusRegen = 6;
     */
    OtherActionFocusRegen = 6,
    /**
     * For threat generated from mana gains.
     *
     * @generated from protobuf enum value: OtherActionManaGain = 10;
     */
    OtherActionManaGain = 10,
    /**
     * For threat generated from rage gains.
     *
     * @generated from protobuf enum value: OtherActionRageGain = 11;
     */
    OtherActionRageGain = 11,
    /**
     * A white hit, can be main hand or off hand.
     *
     * @generated from protobuf enum value: OtherActionAttack = 3;
     */
    OtherActionAttack = 3,
    /**
     * Default shoot action using a wand/bow/gun.
     *
     * @generated from protobuf enum value: OtherActionShoot = 4;
     */
    OtherActionShoot = 4,
    /**
     * Represents a grouping of all pet actions. Only used by the UI.
     *
     * @generated from protobuf enum value: OtherActionPet = 7;
     */
    OtherActionPet = 7,
    /**
     * Refund of a resource like Energy or Rage, when the ability didn't land.
     *
     * @generated from protobuf enum value: OtherActionRefund = 8;
     */
    OtherActionRefund = 8,
    /**
     * Indicates damage taken; used for rage gen.
     *
     * @generated from protobuf enum value: OtherActionDamageTaken = 9;
     */
    OtherActionDamageTaken = 9,
    /**
     * Indicates healing received from healing model.
     *
     * @generated from protobuf enum value: OtherActionHealingModel = 12;
     */
    OtherActionHealingModel = 12,
    /**
     * Indicates healing received from healing model.
     *
     * @generated from protobuf enum value: OtherActionBloodRuneGain = 13;
     */
    OtherActionBloodRuneGain = 13,
    /**
     * Indicates healing received from healing model.
     *
     * @generated from protobuf enum value: OtherActionFrostRuneGain = 14;
     */
    OtherActionFrostRuneGain = 14,
    /**
     * Indicates healing received from healing model.
     *
     * @generated from protobuf enum value: OtherActionUnholyRuneGain = 15;
     */
    OtherActionUnholyRuneGain = 15,
    /**
     * Indicates healing received from healing model.
     *
     * @generated from protobuf enum value: OtherActionDeathRuneGain = 16;
     */
    OtherActionDeathRuneGain = 16,
    /**
     * Used by APL to generically refer to either the prepull or combat potion.
     *
     * @generated from protobuf enum value: OtherActionPotion = 17;
     */
    OtherActionPotion = 17
}
/**
 * @generated from protobuf enum proto.Suffix
 */
export enum Suffix {
    /**
     * @generated from protobuf enum value: SuffixNone = 0;
     */
    SuffixNone = 0,
    /**
     * @generated from protobuf enum value: SuffixMonkey = 5;
     */
    SuffixMonkey = 5,
    /**
     * @generated from protobuf enum value: SuffixEagle = 6;
     */
    SuffixEagle = 6,
    /**
     * @generated from protobuf enum value: SuffixBear = 7;
     */
    SuffixBear = 7,
    /**
     * @generated from protobuf enum value: SuffixWhale = 8;
     */
    SuffixWhale = 8,
    /**
     * @generated from protobuf enum value: SuffixOwl = 9;
     */
    SuffixOwl = 9,
    /**
     * @generated from protobuf enum value: SuffixGorilla = 10;
     */
    SuffixGorilla = 10,
    /**
     * @generated from protobuf enum value: SuffixFalcon = 11;
     */
    SuffixFalcon = 11,
    /**
     * @generated from protobuf enum value: SuffixBoar = 12;
     */
    SuffixBoar = 12,
    /**
     * @generated from protobuf enum value: SuffixWolf = 13;
     */
    SuffixWolf = 13,
    /**
     * @generated from protobuf enum value: SuffixTiger = 14;
     */
    SuffixTiger = 14,
    /**
     * @generated from protobuf enum value: SuffixSpirit = 15;
     */
    SuffixSpirit = 15,
    /**
     * @generated from protobuf enum value: SuffixStamina = 16;
     */
    SuffixStamina = 16,
    /**
     * @generated from protobuf enum value: SuffixStrength = 17;
     */
    SuffixStrength = 17,
    /**
     * @generated from protobuf enum value: SuffixAgility = 18;
     */
    SuffixAgility = 18,
    /**
     * @generated from protobuf enum value: SuffixIntellect = 19;
     */
    SuffixIntellect = 19,
    /**
     * @generated from protobuf enum value: SuffixPower = 20;
     */
    SuffixPower = 20,
    /**
     * @generated from protobuf enum value: SuffixArcaneWrath = 21;
     */
    SuffixArcaneWrath = 21,
    /**
     * @generated from protobuf enum value: SuffixFieryWrath = 22;
     */
    SuffixFieryWrath = 22,
    /**
     * @generated from protobuf enum value: SuffixFrozenWrath = 23;
     */
    SuffixFrozenWrath = 23,
    /**
     * @generated from protobuf enum value: SuffixNaturesWrath = 24;
     */
    SuffixNaturesWrath = 24,
    /**
     * @generated from protobuf enum value: SuffixShadowWrath = 25;
     */
    SuffixShadowWrath = 25,
    /**
     * @generated from protobuf enum value: SuffixSpellPower = 26;
     */
    SuffixSpellPower = 26,
    /**
     * @generated from protobuf enum value: SuffixDefense = 27;
     */
    SuffixDefense = 27,
    /**
     * @generated from protobuf enum value: SuffixRegeneration = 28;
     */
    SuffixRegeneration = 28,
    /**
     * @generated from protobuf enum value: SuffixEluding = 29;
     */
    SuffixEluding = 29,
    /**
     * @generated from protobuf enum value: SuffixConcentration = 30;
     */
    SuffixConcentration = 30,
    /**
     * @generated from protobuf enum value: SuffixArcaneProtection = 31;
     */
    SuffixArcaneProtection = 31,
    /**
     * @generated from protobuf enum value: SuffixFireProtection = 32;
     */
    SuffixFireProtection = 32,
    /**
     * @generated from protobuf enum value: SuffixFrostProtection = 33;
     */
    SuffixFrostProtection = 33,
    /**
     * @generated from protobuf enum value: SuffixNatureProtection = 34;
     */
    SuffixNatureProtection = 34,
    /**
     * @generated from protobuf enum value: SuffixShadowProtection = 35;
     */
    SuffixShadowProtection = 35,
    /**
     * @generated from protobuf enum value: SuffixSorcerer = 36;
     */
    SuffixSorcerer = 36,
    /**
     * @generated from protobuf enum value: SuffixPhysician = 37;
     */
    SuffixPhysician = 37,
    /**
     * @generated from protobuf enum value: SuffixProphet = 38;
     */
    SuffixProphet = 38,
    /**
     * @generated from protobuf enum value: SuffixInvoker = 39;
     */
    SuffixInvoker = 39,
    /**
     * @generated from protobuf enum value: SuffixBandit = 40;
     */
    SuffixBandit = 40,
    /**
     * @generated from protobuf enum value: SuffixBeast = 41;
     */
    SuffixBeast = 41,
    /**
     * @generated from protobuf enum value: SuffixHierophant = 42;
     */
    SuffixHierophant = 42,
    /**
     * @generated from protobuf enum value: SuffixSoldier = 43;
     */
    SuffixSoldier = 43,
    /**
     * @generated from protobuf enum value: SuffixElder = 44;
     */
    SuffixElder = 44,
    /**
     * @generated from protobuf enum value: SuffixChampion = 45;
     */
    SuffixChampion = 45,
    /**
     * @generated from protobuf enum value: SuffixTest = 46;
     */
    SuffixTest = 46,
    /**
     * @generated from protobuf enum value: SuffixBlocking = 47;
     */
    SuffixBlocking = 47,
    /**
     * @generated from protobuf enum value: SuffixPaladinTesting = 48;
     */
    SuffixPaladinTesting = 48,
    /**
     * @generated from protobuf enum value: SuffixGrove = 49;
     */
    SuffixGrove = 49,
    /**
     * @generated from protobuf enum value: SuffixHunt = 50;
     */
    SuffixHunt = 50,
    /**
     * @generated from protobuf enum value: SuffixMind = 51;
     */
    SuffixMind = 51,
    /**
     * @generated from protobuf enum value: SuffixCrusade = 52;
     */
    SuffixCrusade = 52,
    /**
     * @generated from protobuf enum value: SuffixVision = 53;
     */
    SuffixVision = 53,
    /**
     * @generated from protobuf enum value: SuffixAncestor = 54;
     */
    SuffixAncestor = 54,
    /**
     * @generated from protobuf enum value: SuffixNightmare = 55;
     */
    SuffixNightmare = 55,
    /**
     * @generated from protobuf enum value: SuffixBattle = 56;
     */
    SuffixBattle = 56,
    /**
     * @generated from protobuf enum value: SuffixShadow = 57;
     */
    SuffixShadow = 57,
    /**
     * @generated from protobuf enum value: SuffixSun = 58;
     */
    SuffixSun = 58,
    /**
     * @generated from protobuf enum value: SuffixMoon = 59;
     */
    SuffixMoon = 59,
    /**
     * @generated from protobuf enum value: SuffixWild = 60;
     */
    SuffixWild = 60,
    /**
     * @generated from protobuf enum value: SuffixSpellPowerResistance = 61;
     */
    SuffixSpellPowerResistance = 61,
    /**
     * @generated from protobuf enum value: SuffixStrengthResistance = 62;
     */
    SuffixStrengthResistance = 62,
    /**
     * @generated from protobuf enum value: SuffixAgilityResistance = 63;
     */
    SuffixAgilityResistance = 63,
    /**
     * @generated from protobuf enum value: SuffixPowerResistance = 64;
     */
    SuffixPowerResistance = 64,
    /**
     * @generated from protobuf enum value: SuffixMagicResistance = 65;
     */
    SuffixMagicResistance = 65,
    /**
     * @generated from protobuf enum value: SuffixKnight = 66;
     */
    SuffixKnight = 66,
    /**
     * @generated from protobuf enum value: SuffixSeer = 67;
     */
    SuffixSeer = 67,
    /**
     * @generated from protobuf enum value: SuffixBear60 = 68;
     */
    SuffixBear60 = 68,
    /**
     * @generated from protobuf enum value: SuffixEagle60 = 69;
     */
    SuffixEagle60 = 69,
    /**
     * @generated from protobuf enum value: SuffixAncestor60 = 70;
     */
    SuffixAncestor60 = 70,
    /**
     * @generated from protobuf enum value: SuffixBandit60 = 71;
     */
    SuffixBandit60 = 71,
    /**
     * @generated from protobuf enum value: SuffixBattle60 = 72;
     */
    SuffixBattle60 = 72,
    /**
     * @generated from protobuf enum value: SuffixElder60 = 73;
     */
    SuffixElder60 = 73,
    /**
     * @generated from protobuf enum value: SuffixBeast60 = 74;
     */
    SuffixBeast60 = 74,
    /**
     * @generated from protobuf enum value: SuffixChampion60 = 75;
     */
    SuffixChampion60 = 75,
    /**
     * @generated from protobuf enum value: SuffixGrove60 = 76;
     */
    SuffixGrove60 = 76,
    /**
     * @generated from protobuf enum value: SuffixKnight60 = 77;
     */
    SuffixKnight60 = 77,
    /**
     * @generated from protobuf enum value: SuffixMonkey60 = 78;
     */
    SuffixMonkey60 = 78,
    /**
     * @generated from protobuf enum value: SuffixMoon60 = 79;
     */
    SuffixMoon60 = 79,
    /**
     * @generated from protobuf enum value: SuffixWild60 = 80;
     */
    SuffixWild60 = 80,
    /**
     * @generated from protobuf enum value: SuffixWhale60 = 81;
     */
    SuffixWhale60 = 81,
    /**
     * @generated from protobuf enum value: SuffixVision60 = 82;
     */
    SuffixVision60 = 82,
    /**
     * @generated from protobuf enum value: SuffixSun60 = 83;
     */
    SuffixSun60 = 83,
    /**
     * @generated from protobuf enum value: SuffixStamina60 = 84;
     */
    SuffixStamina60 = 84,
    /**
     * @generated from protobuf enum value: SuffixSorcerer60 = 85;
     */
    SuffixSorcerer60 = 85,
    /**
     * @generated from protobuf enum value: SuffixSoldier60 = 86;
     */
    SuffixSoldier60 = 86,
    /**
     * @generated from protobuf enum value: SuffixShadow60 = 87;
     */
    SuffixShadow60 = 87,
    /**
     * @generated from protobuf enum value: SuffixForeseer = 88;
     */
    SuffixForeseer = 88,
    /**
     * @generated from protobuf enum value: SuffixThief = 89;
     */
    SuffixThief = 89,
    /**
     * @generated from protobuf enum value: SuffixNecromancer = 90;
     */
    SuffixNecromancer = 90,
    /**
     * @generated from protobuf enum value: SuffixMarksman = 91;
     */
    SuffixMarksman = 91,
    /**
     * @generated from protobuf enum value: SuffixSquire = 92;
     */
    SuffixSquire = 92,
    /**
     * @generated from protobuf enum value: SuffixRestoration = 93;
     */
    SuffixRestoration = 93
}
// @generated message type with reflection information, may provide speed optimized methods
class UnitStats$Type extends MessageType<UnitStats> {
    constructor() {
        super("proto.UnitStats", [
            { no: 1, name: "stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "pseudo_stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<UnitStats>): UnitStats {
        const message = { stats: [], pseudoStats: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UnitStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnitStats): UnitStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated double stats */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stats.push(reader.double());
                    else
                        message.stats.push(reader.double());
                    break;
                case /* repeated double pseudo_stats */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.pseudoStats.push(reader.double());
                    else
                        message.pseudoStats.push(reader.double());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnitStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated double stats = 1; */
        if (message.stats.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stats.length; i++)
                writer.double(message.stats[i]);
            writer.join();
        }
        /* repeated double pseudo_stats = 2; */
        if (message.pseudoStats.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.pseudoStats.length; i++)
                writer.double(message.pseudoStats[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UnitStats
 */
export const UnitStats = new UnitStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaidBuffs$Type extends MessageType<RaidBuffs> {
    constructor() {
        super("proto.RaidBuffs", [
            { no: 1, name: "gift_of_the_wild", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 2, name: "power_word_fortitude", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 3, name: "commanding_shout", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 4, name: "blood_pact", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 5, name: "horn_of_winter", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "strength_of_earth_totem", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 7, name: "arcane_brilliance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "fel_intelligence", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 9, name: "divine_spirit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "battle_shout", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 11, name: "trueshot_aura", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "unleashed_rage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "abominations_might", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "leader_of_the_pack", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 15, name: "rampage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "icy_talons", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "windfury_totem", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 18, name: "totem_of_wrath", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "flametongue_totem", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 43, name: "demonic_pact", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "swift_retribution", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "moonkin_aura", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 23, name: "elemental_oath", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "wrath_of_air_totem", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "ferocious_inspiration", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "sanctified_retribution", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "arcane_empowerment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 28, name: "mana_spring_totem", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 33, name: "shadow_protection", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 45, name: "nature_resistance_totem", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 46, name: "aspect_of_the_wild", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 47, name: "frost_resistance_aura", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 48, name: "frost_resistance_totem", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "bloodlust", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 30, name: "thorns", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 31, name: "devotion_aura", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 42, name: "stoneskin_totem", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 32, name: "retribution_aura", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 34, name: "drums_of_forgotten_kings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 35, name: "drums_of_the_wild", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 36, name: "scroll_of_protection", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 37, name: "scroll_of_stamina", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 38, name: "scroll_of_strength", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 39, name: "scroll_of_agility", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 40, name: "scroll_of_intellect", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 41, name: "scroll_of_spirit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RaidBuffs>): RaidBuffs {
        const message = { giftOfTheWild: 0, powerWordFortitude: 0, commandingShout: 0, bloodPact: 0, hornOfWinter: false, strengthOfEarthTotem: 0, arcaneBrilliance: false, felIntelligence: 0, divineSpirit: false, battleShout: 0, trueshotAura: false, unleashedRage: false, abominationsMight: false, leaderOfThePack: 0, rampage: false, icyTalons: false, windfuryTotem: 0, totemOfWrath: false, flametongueTotem: false, demonicPact: 0, swiftRetribution: false, moonkinAura: 0, elementalOath: false, wrathOfAirTotem: false, ferociousInspiration: false, sanctifiedRetribution: false, arcaneEmpowerment: false, manaSpringTotem: 0, shadowProtection: false, natureResistanceTotem: false, aspectOfTheWild: false, frostResistanceAura: false, frostResistanceTotem: false, bloodlust: false, thorns: 0, devotionAura: 0, stoneskinTotem: 0, retributionAura: false, drumsOfForgottenKings: false, drumsOfTheWild: false, scrollOfProtection: false, scrollOfStamina: false, scrollOfStrength: false, scrollOfAgility: false, scrollOfIntellect: false, scrollOfSpirit: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RaidBuffs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaidBuffs): RaidBuffs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.TristateEffect gift_of_the_wild */ 1:
                    message.giftOfTheWild = reader.int32();
                    break;
                case /* proto.TristateEffect power_word_fortitude */ 2:
                    message.powerWordFortitude = reader.int32();
                    break;
                case /* proto.TristateEffect commanding_shout */ 3:
                    message.commandingShout = reader.int32();
                    break;
                case /* proto.TristateEffect blood_pact */ 4:
                    message.bloodPact = reader.int32();
                    break;
                case /* bool horn_of_winter */ 5:
                    message.hornOfWinter = reader.bool();
                    break;
                case /* proto.TristateEffect strength_of_earth_totem */ 6:
                    message.strengthOfEarthTotem = reader.int32();
                    break;
                case /* bool arcane_brilliance */ 7:
                    message.arcaneBrilliance = reader.bool();
                    break;
                case /* proto.TristateEffect fel_intelligence */ 8:
                    message.felIntelligence = reader.int32();
                    break;
                case /* bool divine_spirit */ 9:
                    message.divineSpirit = reader.bool();
                    break;
                case /* proto.TristateEffect battle_shout */ 10:
                    message.battleShout = reader.int32();
                    break;
                case /* bool trueshot_aura */ 11:
                    message.trueshotAura = reader.bool();
                    break;
                case /* bool unleashed_rage */ 12:
                    message.unleashedRage = reader.bool();
                    break;
                case /* bool abominations_might */ 13:
                    message.abominationsMight = reader.bool();
                    break;
                case /* proto.TristateEffect leader_of_the_pack */ 14:
                    message.leaderOfThePack = reader.int32();
                    break;
                case /* bool rampage */ 15:
                    message.rampage = reader.bool();
                    break;
                case /* bool icy_talons */ 16:
                    message.icyTalons = reader.bool();
                    break;
                case /* proto.TristateEffect windfury_totem */ 17:
                    message.windfuryTotem = reader.int32();
                    break;
                case /* bool totem_of_wrath */ 18:
                    message.totemOfWrath = reader.bool();
                    break;
                case /* bool flametongue_totem */ 19:
                    message.flametongueTotem = reader.bool();
                    break;
                case /* int32 demonic_pact */ 43:
                    message.demonicPact = reader.int32();
                    break;
                case /* bool swift_retribution */ 21:
                    message.swiftRetribution = reader.bool();
                    break;
                case /* proto.TristateEffect moonkin_aura */ 22:
                    message.moonkinAura = reader.int32();
                    break;
                case /* bool elemental_oath */ 23:
                    message.elementalOath = reader.bool();
                    break;
                case /* bool wrath_of_air_totem */ 24:
                    message.wrathOfAirTotem = reader.bool();
                    break;
                case /* bool ferocious_inspiration */ 25:
                    message.ferociousInspiration = reader.bool();
                    break;
                case /* bool sanctified_retribution */ 26:
                    message.sanctifiedRetribution = reader.bool();
                    break;
                case /* bool arcane_empowerment */ 27:
                    message.arcaneEmpowerment = reader.bool();
                    break;
                case /* proto.TristateEffect mana_spring_totem */ 28:
                    message.manaSpringTotem = reader.int32();
                    break;
                case /* bool shadow_protection */ 33:
                    message.shadowProtection = reader.bool();
                    break;
                case /* bool nature_resistance_totem */ 45:
                    message.natureResistanceTotem = reader.bool();
                    break;
                case /* bool aspect_of_the_wild */ 46:
                    message.aspectOfTheWild = reader.bool();
                    break;
                case /* bool frost_resistance_aura */ 47:
                    message.frostResistanceAura = reader.bool();
                    break;
                case /* bool frost_resistance_totem */ 48:
                    message.frostResistanceTotem = reader.bool();
                    break;
                case /* bool bloodlust */ 29:
                    message.bloodlust = reader.bool();
                    break;
                case /* proto.TristateEffect thorns */ 30:
                    message.thorns = reader.int32();
                    break;
                case /* proto.TristateEffect devotion_aura */ 31:
                    message.devotionAura = reader.int32();
                    break;
                case /* proto.TristateEffect stoneskin_totem */ 42:
                    message.stoneskinTotem = reader.int32();
                    break;
                case /* bool retribution_aura */ 32:
                    message.retributionAura = reader.bool();
                    break;
                case /* bool drums_of_forgotten_kings */ 34:
                    message.drumsOfForgottenKings = reader.bool();
                    break;
                case /* bool drums_of_the_wild */ 35:
                    message.drumsOfTheWild = reader.bool();
                    break;
                case /* bool scroll_of_protection */ 36:
                    message.scrollOfProtection = reader.bool();
                    break;
                case /* bool scroll_of_stamina */ 37:
                    message.scrollOfStamina = reader.bool();
                    break;
                case /* bool scroll_of_strength */ 38:
                    message.scrollOfStrength = reader.bool();
                    break;
                case /* bool scroll_of_agility */ 39:
                    message.scrollOfAgility = reader.bool();
                    break;
                case /* bool scroll_of_intellect */ 40:
                    message.scrollOfIntellect = reader.bool();
                    break;
                case /* bool scroll_of_spirit */ 41:
                    message.scrollOfSpirit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaidBuffs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.TristateEffect gift_of_the_wild = 1; */
        if (message.giftOfTheWild !== 0)
            writer.tag(1, WireType.Varint).int32(message.giftOfTheWild);
        /* proto.TristateEffect power_word_fortitude = 2; */
        if (message.powerWordFortitude !== 0)
            writer.tag(2, WireType.Varint).int32(message.powerWordFortitude);
        /* proto.TristateEffect commanding_shout = 3; */
        if (message.commandingShout !== 0)
            writer.tag(3, WireType.Varint).int32(message.commandingShout);
        /* proto.TristateEffect blood_pact = 4; */
        if (message.bloodPact !== 0)
            writer.tag(4, WireType.Varint).int32(message.bloodPact);
        /* bool horn_of_winter = 5; */
        if (message.hornOfWinter !== false)
            writer.tag(5, WireType.Varint).bool(message.hornOfWinter);
        /* proto.TristateEffect strength_of_earth_totem = 6; */
        if (message.strengthOfEarthTotem !== 0)
            writer.tag(6, WireType.Varint).int32(message.strengthOfEarthTotem);
        /* bool arcane_brilliance = 7; */
        if (message.arcaneBrilliance !== false)
            writer.tag(7, WireType.Varint).bool(message.arcaneBrilliance);
        /* proto.TristateEffect fel_intelligence = 8; */
        if (message.felIntelligence !== 0)
            writer.tag(8, WireType.Varint).int32(message.felIntelligence);
        /* bool divine_spirit = 9; */
        if (message.divineSpirit !== false)
            writer.tag(9, WireType.Varint).bool(message.divineSpirit);
        /* proto.TristateEffect battle_shout = 10; */
        if (message.battleShout !== 0)
            writer.tag(10, WireType.Varint).int32(message.battleShout);
        /* bool trueshot_aura = 11; */
        if (message.trueshotAura !== false)
            writer.tag(11, WireType.Varint).bool(message.trueshotAura);
        /* bool unleashed_rage = 12; */
        if (message.unleashedRage !== false)
            writer.tag(12, WireType.Varint).bool(message.unleashedRage);
        /* bool abominations_might = 13; */
        if (message.abominationsMight !== false)
            writer.tag(13, WireType.Varint).bool(message.abominationsMight);
        /* proto.TristateEffect leader_of_the_pack = 14; */
        if (message.leaderOfThePack !== 0)
            writer.tag(14, WireType.Varint).int32(message.leaderOfThePack);
        /* bool rampage = 15; */
        if (message.rampage !== false)
            writer.tag(15, WireType.Varint).bool(message.rampage);
        /* bool icy_talons = 16; */
        if (message.icyTalons !== false)
            writer.tag(16, WireType.Varint).bool(message.icyTalons);
        /* proto.TristateEffect windfury_totem = 17; */
        if (message.windfuryTotem !== 0)
            writer.tag(17, WireType.Varint).int32(message.windfuryTotem);
        /* bool totem_of_wrath = 18; */
        if (message.totemOfWrath !== false)
            writer.tag(18, WireType.Varint).bool(message.totemOfWrath);
        /* bool flametongue_totem = 19; */
        if (message.flametongueTotem !== false)
            writer.tag(19, WireType.Varint).bool(message.flametongueTotem);
        /* int32 demonic_pact = 43; */
        if (message.demonicPact !== 0)
            writer.tag(43, WireType.Varint).int32(message.demonicPact);
        /* bool swift_retribution = 21; */
        if (message.swiftRetribution !== false)
            writer.tag(21, WireType.Varint).bool(message.swiftRetribution);
        /* proto.TristateEffect moonkin_aura = 22; */
        if (message.moonkinAura !== 0)
            writer.tag(22, WireType.Varint).int32(message.moonkinAura);
        /* bool elemental_oath = 23; */
        if (message.elementalOath !== false)
            writer.tag(23, WireType.Varint).bool(message.elementalOath);
        /* bool wrath_of_air_totem = 24; */
        if (message.wrathOfAirTotem !== false)
            writer.tag(24, WireType.Varint).bool(message.wrathOfAirTotem);
        /* bool ferocious_inspiration = 25; */
        if (message.ferociousInspiration !== false)
            writer.tag(25, WireType.Varint).bool(message.ferociousInspiration);
        /* bool sanctified_retribution = 26; */
        if (message.sanctifiedRetribution !== false)
            writer.tag(26, WireType.Varint).bool(message.sanctifiedRetribution);
        /* bool arcane_empowerment = 27; */
        if (message.arcaneEmpowerment !== false)
            writer.tag(27, WireType.Varint).bool(message.arcaneEmpowerment);
        /* proto.TristateEffect mana_spring_totem = 28; */
        if (message.manaSpringTotem !== 0)
            writer.tag(28, WireType.Varint).int32(message.manaSpringTotem);
        /* bool shadow_protection = 33; */
        if (message.shadowProtection !== false)
            writer.tag(33, WireType.Varint).bool(message.shadowProtection);
        /* bool nature_resistance_totem = 45; */
        if (message.natureResistanceTotem !== false)
            writer.tag(45, WireType.Varint).bool(message.natureResistanceTotem);
        /* bool aspect_of_the_wild = 46; */
        if (message.aspectOfTheWild !== false)
            writer.tag(46, WireType.Varint).bool(message.aspectOfTheWild);
        /* bool frost_resistance_aura = 47; */
        if (message.frostResistanceAura !== false)
            writer.tag(47, WireType.Varint).bool(message.frostResistanceAura);
        /* bool frost_resistance_totem = 48; */
        if (message.frostResistanceTotem !== false)
            writer.tag(48, WireType.Varint).bool(message.frostResistanceTotem);
        /* bool bloodlust = 29; */
        if (message.bloodlust !== false)
            writer.tag(29, WireType.Varint).bool(message.bloodlust);
        /* proto.TristateEffect thorns = 30; */
        if (message.thorns !== 0)
            writer.tag(30, WireType.Varint).int32(message.thorns);
        /* proto.TristateEffect devotion_aura = 31; */
        if (message.devotionAura !== 0)
            writer.tag(31, WireType.Varint).int32(message.devotionAura);
        /* proto.TristateEffect stoneskin_totem = 42; */
        if (message.stoneskinTotem !== 0)
            writer.tag(42, WireType.Varint).int32(message.stoneskinTotem);
        /* bool retribution_aura = 32; */
        if (message.retributionAura !== false)
            writer.tag(32, WireType.Varint).bool(message.retributionAura);
        /* bool drums_of_forgotten_kings = 34; */
        if (message.drumsOfForgottenKings !== false)
            writer.tag(34, WireType.Varint).bool(message.drumsOfForgottenKings);
        /* bool drums_of_the_wild = 35; */
        if (message.drumsOfTheWild !== false)
            writer.tag(35, WireType.Varint).bool(message.drumsOfTheWild);
        /* bool scroll_of_protection = 36; */
        if (message.scrollOfProtection !== false)
            writer.tag(36, WireType.Varint).bool(message.scrollOfProtection);
        /* bool scroll_of_stamina = 37; */
        if (message.scrollOfStamina !== false)
            writer.tag(37, WireType.Varint).bool(message.scrollOfStamina);
        /* bool scroll_of_strength = 38; */
        if (message.scrollOfStrength !== false)
            writer.tag(38, WireType.Varint).bool(message.scrollOfStrength);
        /* bool scroll_of_agility = 39; */
        if (message.scrollOfAgility !== false)
            writer.tag(39, WireType.Varint).bool(message.scrollOfAgility);
        /* bool scroll_of_intellect = 40; */
        if (message.scrollOfIntellect !== false)
            writer.tag(40, WireType.Varint).bool(message.scrollOfIntellect);
        /* bool scroll_of_spirit = 41; */
        if (message.scrollOfSpirit !== false)
            writer.tag(41, WireType.Varint).bool(message.scrollOfSpirit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RaidBuffs
 */
export const RaidBuffs = new RaidBuffs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PartyBuffs$Type extends MessageType<PartyBuffs> {
    constructor() {
        super("proto.PartyBuffs", [
            { no: 1, name: "atiesh_mage", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "atiesh_warlock", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "braided_eternium_chain", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "eye_of_the_night", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "chain_of_the_twilight_owl", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "mana_tide_totems", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "heroic_presence", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PartyBuffs>): PartyBuffs {
        const message = { atieshMage: 0, atieshWarlock: 0, braidedEterniumChain: false, eyeOfTheNight: false, chainOfTheTwilightOwl: false, manaTideTotems: 0, heroicPresence: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PartyBuffs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PartyBuffs): PartyBuffs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 atiesh_mage */ 1:
                    message.atieshMage = reader.int32();
                    break;
                case /* int32 atiesh_warlock */ 2:
                    message.atieshWarlock = reader.int32();
                    break;
                case /* bool braided_eternium_chain */ 3:
                    message.braidedEterniumChain = reader.bool();
                    break;
                case /* bool eye_of_the_night */ 4:
                    message.eyeOfTheNight = reader.bool();
                    break;
                case /* bool chain_of_the_twilight_owl */ 5:
                    message.chainOfTheTwilightOwl = reader.bool();
                    break;
                case /* int32 mana_tide_totems */ 6:
                    message.manaTideTotems = reader.int32();
                    break;
                case /* bool heroic_presence */ 7:
                    message.heroicPresence = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PartyBuffs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 atiesh_mage = 1; */
        if (message.atieshMage !== 0)
            writer.tag(1, WireType.Varint).int32(message.atieshMage);
        /* int32 atiesh_warlock = 2; */
        if (message.atieshWarlock !== 0)
            writer.tag(2, WireType.Varint).int32(message.atieshWarlock);
        /* bool braided_eternium_chain = 3; */
        if (message.braidedEterniumChain !== false)
            writer.tag(3, WireType.Varint).bool(message.braidedEterniumChain);
        /* bool eye_of_the_night = 4; */
        if (message.eyeOfTheNight !== false)
            writer.tag(4, WireType.Varint).bool(message.eyeOfTheNight);
        /* bool chain_of_the_twilight_owl = 5; */
        if (message.chainOfTheTwilightOwl !== false)
            writer.tag(5, WireType.Varint).bool(message.chainOfTheTwilightOwl);
        /* int32 mana_tide_totems = 6; */
        if (message.manaTideTotems !== 0)
            writer.tag(6, WireType.Varint).int32(message.manaTideTotems);
        /* bool heroic_presence = 7; */
        if (message.heroicPresence !== false)
            writer.tag(7, WireType.Varint).bool(message.heroicPresence);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.PartyBuffs
 */
export const PartyBuffs = new PartyBuffs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IndividualBuffs$Type extends MessageType<IndividualBuffs> {
    constructor() {
        super("proto.IndividualBuffs", [
            { no: 1, name: "blessing_of_kings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "blessing_of_wisdom", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 3, name: "blessing_of_might", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 4, name: "blessing_of_sanctuary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "vigilance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "renewed_hope", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "hymn_of_hope", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "hand_of_salvation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "rapture", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "innervates", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "power_infusions", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "unholy_frenzy", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "revitalize_rejuvination", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "revitalize_wild_growth", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "tricks_of_the_trades", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "divine_guardians", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "pain_suppressions", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "hand_of_sacrifices", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "guardian_spirits", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "shattering_throws", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "vampiric_touch", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "hunting_party", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "judgements_of_the_wise", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "improved_soul_leech", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "enduring_winter", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "focus_magic", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<IndividualBuffs>): IndividualBuffs {
        const message = { blessingOfKings: false, blessingOfWisdom: 0, blessingOfMight: 0, blessingOfSanctuary: false, vigilance: false, renewedHope: false, hymnOfHope: 0, handOfSalvation: 0, rapture: 0, innervates: 0, powerInfusions: 0, unholyFrenzy: 0, revitalizeRejuvination: 0, revitalizeWildGrowth: 0, tricksOfTheTrades: 0, divineGuardians: 0, painSuppressions: 0, handOfSacrifices: 0, guardianSpirits: 0, shatteringThrows: 0, vampiricTouch: false, huntingParty: false, judgementsOfTheWise: false, improvedSoulLeech: false, enduringWinter: false, focusMagic: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<IndividualBuffs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IndividualBuffs): IndividualBuffs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool blessing_of_kings */ 1:
                    message.blessingOfKings = reader.bool();
                    break;
                case /* proto.TristateEffect blessing_of_wisdom */ 2:
                    message.blessingOfWisdom = reader.int32();
                    break;
                case /* proto.TristateEffect blessing_of_might */ 3:
                    message.blessingOfMight = reader.int32();
                    break;
                case /* bool blessing_of_sanctuary */ 4:
                    message.blessingOfSanctuary = reader.bool();
                    break;
                case /* bool vigilance */ 5:
                    message.vigilance = reader.bool();
                    break;
                case /* bool renewed_hope */ 6:
                    message.renewedHope = reader.bool();
                    break;
                case /* int32 hymn_of_hope */ 7:
                    message.hymnOfHope = reader.int32();
                    break;
                case /* int32 hand_of_salvation */ 8:
                    message.handOfSalvation = reader.int32();
                    break;
                case /* int32 rapture */ 9:
                    message.rapture = reader.int32();
                    break;
                case /* int32 innervates */ 10:
                    message.innervates = reader.int32();
                    break;
                case /* int32 power_infusions */ 11:
                    message.powerInfusions = reader.int32();
                    break;
                case /* int32 unholy_frenzy */ 12:
                    message.unholyFrenzy = reader.int32();
                    break;
                case /* int32 revitalize_rejuvination */ 13:
                    message.revitalizeRejuvination = reader.int32();
                    break;
                case /* int32 revitalize_wild_growth */ 21:
                    message.revitalizeWildGrowth = reader.int32();
                    break;
                case /* int32 tricks_of_the_trades */ 19:
                    message.tricksOfTheTrades = reader.int32();
                    break;
                case /* int32 divine_guardians */ 23:
                    message.divineGuardians = reader.int32();
                    break;
                case /* int32 pain_suppressions */ 24:
                    message.painSuppressions = reader.int32();
                    break;
                case /* int32 hand_of_sacrifices */ 25:
                    message.handOfSacrifices = reader.int32();
                    break;
                case /* int32 guardian_spirits */ 26:
                    message.guardianSpirits = reader.int32();
                    break;
                case /* int32 shattering_throws */ 20:
                    message.shatteringThrows = reader.int32();
                    break;
                case /* bool vampiric_touch */ 14:
                    message.vampiricTouch = reader.bool();
                    break;
                case /* bool hunting_party */ 15:
                    message.huntingParty = reader.bool();
                    break;
                case /* bool judgements_of_the_wise */ 16:
                    message.judgementsOfTheWise = reader.bool();
                    break;
                case /* bool improved_soul_leech */ 17:
                    message.improvedSoulLeech = reader.bool();
                    break;
                case /* bool enduring_winter */ 18:
                    message.enduringWinter = reader.bool();
                    break;
                case /* bool focus_magic */ 22:
                    message.focusMagic = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IndividualBuffs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool blessing_of_kings = 1; */
        if (message.blessingOfKings !== false)
            writer.tag(1, WireType.Varint).bool(message.blessingOfKings);
        /* proto.TristateEffect blessing_of_wisdom = 2; */
        if (message.blessingOfWisdom !== 0)
            writer.tag(2, WireType.Varint).int32(message.blessingOfWisdom);
        /* proto.TristateEffect blessing_of_might = 3; */
        if (message.blessingOfMight !== 0)
            writer.tag(3, WireType.Varint).int32(message.blessingOfMight);
        /* bool blessing_of_sanctuary = 4; */
        if (message.blessingOfSanctuary !== false)
            writer.tag(4, WireType.Varint).bool(message.blessingOfSanctuary);
        /* bool vigilance = 5; */
        if (message.vigilance !== false)
            writer.tag(5, WireType.Varint).bool(message.vigilance);
        /* bool renewed_hope = 6; */
        if (message.renewedHope !== false)
            writer.tag(6, WireType.Varint).bool(message.renewedHope);
        /* int32 hymn_of_hope = 7; */
        if (message.hymnOfHope !== 0)
            writer.tag(7, WireType.Varint).int32(message.hymnOfHope);
        /* int32 hand_of_salvation = 8; */
        if (message.handOfSalvation !== 0)
            writer.tag(8, WireType.Varint).int32(message.handOfSalvation);
        /* int32 rapture = 9; */
        if (message.rapture !== 0)
            writer.tag(9, WireType.Varint).int32(message.rapture);
        /* int32 innervates = 10; */
        if (message.innervates !== 0)
            writer.tag(10, WireType.Varint).int32(message.innervates);
        /* int32 power_infusions = 11; */
        if (message.powerInfusions !== 0)
            writer.tag(11, WireType.Varint).int32(message.powerInfusions);
        /* int32 unholy_frenzy = 12; */
        if (message.unholyFrenzy !== 0)
            writer.tag(12, WireType.Varint).int32(message.unholyFrenzy);
        /* int32 revitalize_rejuvination = 13; */
        if (message.revitalizeRejuvination !== 0)
            writer.tag(13, WireType.Varint).int32(message.revitalizeRejuvination);
        /* int32 revitalize_wild_growth = 21; */
        if (message.revitalizeWildGrowth !== 0)
            writer.tag(21, WireType.Varint).int32(message.revitalizeWildGrowth);
        /* int32 tricks_of_the_trades = 19; */
        if (message.tricksOfTheTrades !== 0)
            writer.tag(19, WireType.Varint).int32(message.tricksOfTheTrades);
        /* int32 divine_guardians = 23; */
        if (message.divineGuardians !== 0)
            writer.tag(23, WireType.Varint).int32(message.divineGuardians);
        /* int32 pain_suppressions = 24; */
        if (message.painSuppressions !== 0)
            writer.tag(24, WireType.Varint).int32(message.painSuppressions);
        /* int32 hand_of_sacrifices = 25; */
        if (message.handOfSacrifices !== 0)
            writer.tag(25, WireType.Varint).int32(message.handOfSacrifices);
        /* int32 guardian_spirits = 26; */
        if (message.guardianSpirits !== 0)
            writer.tag(26, WireType.Varint).int32(message.guardianSpirits);
        /* int32 shattering_throws = 20; */
        if (message.shatteringThrows !== 0)
            writer.tag(20, WireType.Varint).int32(message.shatteringThrows);
        /* bool vampiric_touch = 14; */
        if (message.vampiricTouch !== false)
            writer.tag(14, WireType.Varint).bool(message.vampiricTouch);
        /* bool hunting_party = 15; */
        if (message.huntingParty !== false)
            writer.tag(15, WireType.Varint).bool(message.huntingParty);
        /* bool judgements_of_the_wise = 16; */
        if (message.judgementsOfTheWise !== false)
            writer.tag(16, WireType.Varint).bool(message.judgementsOfTheWise);
        /* bool improved_soul_leech = 17; */
        if (message.improvedSoulLeech !== false)
            writer.tag(17, WireType.Varint).bool(message.improvedSoulLeech);
        /* bool enduring_winter = 18; */
        if (message.enduringWinter !== false)
            writer.tag(18, WireType.Varint).bool(message.enduringWinter);
        /* bool focus_magic = 22; */
        if (message.focusMagic !== false)
            writer.tag(22, WireType.Varint).bool(message.focusMagic);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.IndividualBuffs
 */
export const IndividualBuffs = new IndividualBuffs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Consumes$Type extends MessageType<Consumes> {
    constructor() {
        super("proto.Consumes", [
            { no: 1, name: "flask", kind: "enum", T: () => ["proto.Flask", Flask] },
            { no: 2, name: "battle_elixir", kind: "enum", T: () => ["proto.BattleElixir", BattleElixir] },
            { no: 3, name: "guardian_elixir", kind: "enum", T: () => ["proto.GuardianElixir", GuardianElixir] },
            { no: 4, name: "weapon_main", kind: "enum", T: () => ["proto.WeaponImbue", WeaponImbue] },
            { no: 5, name: "weapon_off", kind: "enum", T: () => ["proto.WeaponImbue", WeaponImbue] },
            { no: 6, name: "food", kind: "enum", T: () => ["proto.Food", Food] },
            { no: 7, name: "pet_food", kind: "enum", T: () => ["proto.PetFood", PetFood] },
            { no: 8, name: "pet_scroll_of_agility", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "pet_scroll_of_strength", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "default_potion", kind: "enum", T: () => ["proto.Potions", Potions] },
            { no: 11, name: "prepop_potion", kind: "enum", T: () => ["proto.Potions", Potions] },
            { no: 12, name: "default_conjured", kind: "enum", T: () => ["proto.Conjured", Conjured] },
            { no: 14, name: "super_sapper", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "thermal_sapper", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "explosive_decoy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "filler_explosive", kind: "enum", T: () => ["proto.Explosive", Explosive] }
        ]);
    }
    create(value?: PartialMessage<Consumes>): Consumes {
        const message = { flask: 0, battleElixir: 0, guardianElixir: 0, weaponMain: 0, weaponOff: 0, food: 0, petFood: 0, petScrollOfAgility: 0, petScrollOfStrength: 0, defaultPotion: 0, prepopPotion: 0, defaultConjured: 0, superSapper: false, thermalSapper: false, explosiveDecoy: false, fillerExplosive: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Consumes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Consumes): Consumes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Flask flask */ 1:
                    message.flask = reader.int32();
                    break;
                case /* proto.BattleElixir battle_elixir */ 2:
                    message.battleElixir = reader.int32();
                    break;
                case /* proto.GuardianElixir guardian_elixir */ 3:
                    message.guardianElixir = reader.int32();
                    break;
                case /* proto.WeaponImbue weapon_main */ 4:
                    message.weaponMain = reader.int32();
                    break;
                case /* proto.WeaponImbue weapon_off */ 5:
                    message.weaponOff = reader.int32();
                    break;
                case /* proto.Food food */ 6:
                    message.food = reader.int32();
                    break;
                case /* proto.PetFood pet_food */ 7:
                    message.petFood = reader.int32();
                    break;
                case /* int32 pet_scroll_of_agility */ 8:
                    message.petScrollOfAgility = reader.int32();
                    break;
                case /* int32 pet_scroll_of_strength */ 9:
                    message.petScrollOfStrength = reader.int32();
                    break;
                case /* proto.Potions default_potion */ 10:
                    message.defaultPotion = reader.int32();
                    break;
                case /* proto.Potions prepop_potion */ 11:
                    message.prepopPotion = reader.int32();
                    break;
                case /* proto.Conjured default_conjured */ 12:
                    message.defaultConjured = reader.int32();
                    break;
                case /* bool super_sapper */ 14:
                    message.superSapper = reader.bool();
                    break;
                case /* bool thermal_sapper */ 15:
                    message.thermalSapper = reader.bool();
                    break;
                case /* bool explosive_decoy */ 16:
                    message.explosiveDecoy = reader.bool();
                    break;
                case /* proto.Explosive filler_explosive */ 17:
                    message.fillerExplosive = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Consumes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Flask flask = 1; */
        if (message.flask !== 0)
            writer.tag(1, WireType.Varint).int32(message.flask);
        /* proto.BattleElixir battle_elixir = 2; */
        if (message.battleElixir !== 0)
            writer.tag(2, WireType.Varint).int32(message.battleElixir);
        /* proto.GuardianElixir guardian_elixir = 3; */
        if (message.guardianElixir !== 0)
            writer.tag(3, WireType.Varint).int32(message.guardianElixir);
        /* proto.WeaponImbue weapon_main = 4; */
        if (message.weaponMain !== 0)
            writer.tag(4, WireType.Varint).int32(message.weaponMain);
        /* proto.WeaponImbue weapon_off = 5; */
        if (message.weaponOff !== 0)
            writer.tag(5, WireType.Varint).int32(message.weaponOff);
        /* proto.Food food = 6; */
        if (message.food !== 0)
            writer.tag(6, WireType.Varint).int32(message.food);
        /* proto.PetFood pet_food = 7; */
        if (message.petFood !== 0)
            writer.tag(7, WireType.Varint).int32(message.petFood);
        /* int32 pet_scroll_of_agility = 8; */
        if (message.petScrollOfAgility !== 0)
            writer.tag(8, WireType.Varint).int32(message.petScrollOfAgility);
        /* int32 pet_scroll_of_strength = 9; */
        if (message.petScrollOfStrength !== 0)
            writer.tag(9, WireType.Varint).int32(message.petScrollOfStrength);
        /* proto.Potions default_potion = 10; */
        if (message.defaultPotion !== 0)
            writer.tag(10, WireType.Varint).int32(message.defaultPotion);
        /* proto.Potions prepop_potion = 11; */
        if (message.prepopPotion !== 0)
            writer.tag(11, WireType.Varint).int32(message.prepopPotion);
        /* proto.Conjured default_conjured = 12; */
        if (message.defaultConjured !== 0)
            writer.tag(12, WireType.Varint).int32(message.defaultConjured);
        /* bool super_sapper = 14; */
        if (message.superSapper !== false)
            writer.tag(14, WireType.Varint).bool(message.superSapper);
        /* bool thermal_sapper = 15; */
        if (message.thermalSapper !== false)
            writer.tag(15, WireType.Varint).bool(message.thermalSapper);
        /* bool explosive_decoy = 16; */
        if (message.explosiveDecoy !== false)
            writer.tag(16, WireType.Varint).bool(message.explosiveDecoy);
        /* proto.Explosive filler_explosive = 17; */
        if (message.fillerExplosive !== 0)
            writer.tag(17, WireType.Varint).int32(message.fillerExplosive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Consumes
 */
export const Consumes = new Consumes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Debuffs$Type extends MessageType<Debuffs> {
    constructor() {
        super("proto.Debuffs", [
            { no: 1, name: "judgement_of_wisdom", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "judgement_of_light", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "misery", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "faerie_fire", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 5, name: "curse_of_elements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "ebon_plaguebringer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "earth_and_moon", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "heart_of_the_crusader", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "master_poisoner", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "totem_of_wrath", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "shadow_mastery", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "improved_scorch", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "winters_chill", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "blood_frenzy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "savage_combat", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "gift_of_arthas", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "mangle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "trauma", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "stampede", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "expose_armor", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "sunder_armor", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "acid_spit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "curse_of_weakness", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 24, name: "sting", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 37, name: "spore_cloud", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "demoralizing_roar", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 26, name: "demoralizing_shout", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 36, name: "vindication", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 34, name: "demoralizing_screech", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "thunder_clap", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 28, name: "frost_fever", kind: "enum", T: () => ["proto.TristateEffect", TristateEffect] },
            { no: 29, name: "infected_wounds", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 30, name: "judgements_of_the_just", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "insect_swarm", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 32, name: "scorpid_sting", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "shadow_embrace", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 35, name: "hunters_mark", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 38, name: "crystal_yield", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Debuffs>): Debuffs {
        const message = { judgementOfWisdom: false, judgementOfLight: false, misery: false, faerieFire: 0, curseOfElements: false, ebonPlaguebringer: false, earthAndMoon: false, heartOfTheCrusader: false, masterPoisoner: false, totemOfWrath: false, shadowMastery: false, improvedScorch: false, wintersChill: false, bloodFrenzy: false, savageCombat: false, giftOfArthas: false, mangle: false, trauma: false, stampede: false, exposeArmor: false, sunderArmor: false, acidSpit: false, curseOfWeakness: 0, sting: false, sporeCloud: false, demoralizingRoar: 0, demoralizingShout: 0, vindication: false, demoralizingScreech: false, thunderClap: 0, frostFever: 0, infectedWounds: false, judgementsOfTheJust: false, insectSwarm: false, scorpidSting: false, shadowEmbrace: false, huntersMark: 0, crystalYield: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Debuffs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Debuffs): Debuffs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool judgement_of_wisdom */ 1:
                    message.judgementOfWisdom = reader.bool();
                    break;
                case /* bool judgement_of_light */ 2:
                    message.judgementOfLight = reader.bool();
                    break;
                case /* bool misery */ 3:
                    message.misery = reader.bool();
                    break;
                case /* proto.TristateEffect faerie_fire */ 4:
                    message.faerieFire = reader.int32();
                    break;
                case /* bool curse_of_elements */ 5:
                    message.curseOfElements = reader.bool();
                    break;
                case /* bool ebon_plaguebringer */ 6:
                    message.ebonPlaguebringer = reader.bool();
                    break;
                case /* bool earth_and_moon */ 7:
                    message.earthAndMoon = reader.bool();
                    break;
                case /* bool heart_of_the_crusader */ 8:
                    message.heartOfTheCrusader = reader.bool();
                    break;
                case /* bool master_poisoner */ 9:
                    message.masterPoisoner = reader.bool();
                    break;
                case /* bool totem_of_wrath */ 10:
                    message.totemOfWrath = reader.bool();
                    break;
                case /* bool shadow_mastery */ 11:
                    message.shadowMastery = reader.bool();
                    break;
                case /* bool improved_scorch */ 12:
                    message.improvedScorch = reader.bool();
                    break;
                case /* bool winters_chill */ 13:
                    message.wintersChill = reader.bool();
                    break;
                case /* bool blood_frenzy */ 14:
                    message.bloodFrenzy = reader.bool();
                    break;
                case /* bool savage_combat */ 15:
                    message.savageCombat = reader.bool();
                    break;
                case /* bool gift_of_arthas */ 16:
                    message.giftOfArthas = reader.bool();
                    break;
                case /* bool mangle */ 17:
                    message.mangle = reader.bool();
                    break;
                case /* bool trauma */ 18:
                    message.trauma = reader.bool();
                    break;
                case /* bool stampede */ 19:
                    message.stampede = reader.bool();
                    break;
                case /* bool expose_armor */ 20:
                    message.exposeArmor = reader.bool();
                    break;
                case /* bool sunder_armor */ 21:
                    message.sunderArmor = reader.bool();
                    break;
                case /* bool acid_spit */ 22:
                    message.acidSpit = reader.bool();
                    break;
                case /* proto.TristateEffect curse_of_weakness */ 23:
                    message.curseOfWeakness = reader.int32();
                    break;
                case /* bool sting */ 24:
                    message.sting = reader.bool();
                    break;
                case /* bool spore_cloud */ 37:
                    message.sporeCloud = reader.bool();
                    break;
                case /* proto.TristateEffect demoralizing_roar */ 25:
                    message.demoralizingRoar = reader.int32();
                    break;
                case /* proto.TristateEffect demoralizing_shout */ 26:
                    message.demoralizingShout = reader.int32();
                    break;
                case /* bool vindication */ 36:
                    message.vindication = reader.bool();
                    break;
                case /* bool demoralizing_screech */ 34:
                    message.demoralizingScreech = reader.bool();
                    break;
                case /* proto.TristateEffect thunder_clap */ 27:
                    message.thunderClap = reader.int32();
                    break;
                case /* proto.TristateEffect frost_fever */ 28:
                    message.frostFever = reader.int32();
                    break;
                case /* bool infected_wounds */ 29:
                    message.infectedWounds = reader.bool();
                    break;
                case /* bool judgements_of_the_just */ 30:
                    message.judgementsOfTheJust = reader.bool();
                    break;
                case /* bool insect_swarm */ 31:
                    message.insectSwarm = reader.bool();
                    break;
                case /* bool scorpid_sting */ 32:
                    message.scorpidSting = reader.bool();
                    break;
                case /* bool shadow_embrace */ 33:
                    message.shadowEmbrace = reader.bool();
                    break;
                case /* int32 hunters_mark */ 35:
                    message.huntersMark = reader.int32();
                    break;
                case /* bool crystal_yield */ 38:
                    message.crystalYield = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Debuffs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool judgement_of_wisdom = 1; */
        if (message.judgementOfWisdom !== false)
            writer.tag(1, WireType.Varint).bool(message.judgementOfWisdom);
        /* bool judgement_of_light = 2; */
        if (message.judgementOfLight !== false)
            writer.tag(2, WireType.Varint).bool(message.judgementOfLight);
        /* bool misery = 3; */
        if (message.misery !== false)
            writer.tag(3, WireType.Varint).bool(message.misery);
        /* proto.TristateEffect faerie_fire = 4; */
        if (message.faerieFire !== 0)
            writer.tag(4, WireType.Varint).int32(message.faerieFire);
        /* bool curse_of_elements = 5; */
        if (message.curseOfElements !== false)
            writer.tag(5, WireType.Varint).bool(message.curseOfElements);
        /* bool ebon_plaguebringer = 6; */
        if (message.ebonPlaguebringer !== false)
            writer.tag(6, WireType.Varint).bool(message.ebonPlaguebringer);
        /* bool earth_and_moon = 7; */
        if (message.earthAndMoon !== false)
            writer.tag(7, WireType.Varint).bool(message.earthAndMoon);
        /* bool heart_of_the_crusader = 8; */
        if (message.heartOfTheCrusader !== false)
            writer.tag(8, WireType.Varint).bool(message.heartOfTheCrusader);
        /* bool master_poisoner = 9; */
        if (message.masterPoisoner !== false)
            writer.tag(9, WireType.Varint).bool(message.masterPoisoner);
        /* bool totem_of_wrath = 10; */
        if (message.totemOfWrath !== false)
            writer.tag(10, WireType.Varint).bool(message.totemOfWrath);
        /* bool shadow_mastery = 11; */
        if (message.shadowMastery !== false)
            writer.tag(11, WireType.Varint).bool(message.shadowMastery);
        /* bool improved_scorch = 12; */
        if (message.improvedScorch !== false)
            writer.tag(12, WireType.Varint).bool(message.improvedScorch);
        /* bool winters_chill = 13; */
        if (message.wintersChill !== false)
            writer.tag(13, WireType.Varint).bool(message.wintersChill);
        /* bool blood_frenzy = 14; */
        if (message.bloodFrenzy !== false)
            writer.tag(14, WireType.Varint).bool(message.bloodFrenzy);
        /* bool savage_combat = 15; */
        if (message.savageCombat !== false)
            writer.tag(15, WireType.Varint).bool(message.savageCombat);
        /* bool gift_of_arthas = 16; */
        if (message.giftOfArthas !== false)
            writer.tag(16, WireType.Varint).bool(message.giftOfArthas);
        /* bool mangle = 17; */
        if (message.mangle !== false)
            writer.tag(17, WireType.Varint).bool(message.mangle);
        /* bool trauma = 18; */
        if (message.trauma !== false)
            writer.tag(18, WireType.Varint).bool(message.trauma);
        /* bool stampede = 19; */
        if (message.stampede !== false)
            writer.tag(19, WireType.Varint).bool(message.stampede);
        /* bool expose_armor = 20; */
        if (message.exposeArmor !== false)
            writer.tag(20, WireType.Varint).bool(message.exposeArmor);
        /* bool sunder_armor = 21; */
        if (message.sunderArmor !== false)
            writer.tag(21, WireType.Varint).bool(message.sunderArmor);
        /* bool acid_spit = 22; */
        if (message.acidSpit !== false)
            writer.tag(22, WireType.Varint).bool(message.acidSpit);
        /* proto.TristateEffect curse_of_weakness = 23; */
        if (message.curseOfWeakness !== 0)
            writer.tag(23, WireType.Varint).int32(message.curseOfWeakness);
        /* bool sting = 24; */
        if (message.sting !== false)
            writer.tag(24, WireType.Varint).bool(message.sting);
        /* bool spore_cloud = 37; */
        if (message.sporeCloud !== false)
            writer.tag(37, WireType.Varint).bool(message.sporeCloud);
        /* proto.TristateEffect demoralizing_roar = 25; */
        if (message.demoralizingRoar !== 0)
            writer.tag(25, WireType.Varint).int32(message.demoralizingRoar);
        /* proto.TristateEffect demoralizing_shout = 26; */
        if (message.demoralizingShout !== 0)
            writer.tag(26, WireType.Varint).int32(message.demoralizingShout);
        /* bool vindication = 36; */
        if (message.vindication !== false)
            writer.tag(36, WireType.Varint).bool(message.vindication);
        /* bool demoralizing_screech = 34; */
        if (message.demoralizingScreech !== false)
            writer.tag(34, WireType.Varint).bool(message.demoralizingScreech);
        /* proto.TristateEffect thunder_clap = 27; */
        if (message.thunderClap !== 0)
            writer.tag(27, WireType.Varint).int32(message.thunderClap);
        /* proto.TristateEffect frost_fever = 28; */
        if (message.frostFever !== 0)
            writer.tag(28, WireType.Varint).int32(message.frostFever);
        /* bool infected_wounds = 29; */
        if (message.infectedWounds !== false)
            writer.tag(29, WireType.Varint).bool(message.infectedWounds);
        /* bool judgements_of_the_just = 30; */
        if (message.judgementsOfTheJust !== false)
            writer.tag(30, WireType.Varint).bool(message.judgementsOfTheJust);
        /* bool insect_swarm = 31; */
        if (message.insectSwarm !== false)
            writer.tag(31, WireType.Varint).bool(message.insectSwarm);
        /* bool scorpid_sting = 32; */
        if (message.scorpidSting !== false)
            writer.tag(32, WireType.Varint).bool(message.scorpidSting);
        /* bool shadow_embrace = 33; */
        if (message.shadowEmbrace !== false)
            writer.tag(33, WireType.Varint).bool(message.shadowEmbrace);
        /* int32 hunters_mark = 35; */
        if (message.huntersMark !== 0)
            writer.tag(35, WireType.Varint).int32(message.huntersMark);
        /* bool crystal_yield = 38; */
        if (message.crystalYield !== false)
            writer.tag(38, WireType.Varint).bool(message.crystalYield);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Debuffs
 */
export const Debuffs = new Debuffs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TargetInput$Type extends MessageType<TargetInput> {
    constructor() {
        super("proto.TargetInput", [
            { no: 1, name: "input_type", kind: "enum", T: () => ["proto.InputType", InputType] },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "tooltip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "bool_value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "number_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<TargetInput>): TargetInput {
        const message = { inputType: 0, label: "", tooltip: "", boolValue: false, numberValue: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TargetInput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TargetInput): TargetInput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.InputType input_type */ 1:
                    message.inputType = reader.int32();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* string tooltip */ 5:
                    message.tooltip = reader.string();
                    break;
                case /* bool bool_value */ 3:
                    message.boolValue = reader.bool();
                    break;
                case /* double number_value */ 4:
                    message.numberValue = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TargetInput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.InputType input_type = 1; */
        if (message.inputType !== 0)
            writer.tag(1, WireType.Varint).int32(message.inputType);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* string tooltip = 5; */
        if (message.tooltip !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tooltip);
        /* bool bool_value = 3; */
        if (message.boolValue !== false)
            writer.tag(3, WireType.Varint).bool(message.boolValue);
        /* double number_value = 4; */
        if (message.numberValue !== 0)
            writer.tag(4, WireType.Bit64).double(message.numberValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.TargetInput
 */
export const TargetInput = new TargetInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Target$Type extends MessageType<Target> {
    constructor() {
        super("proto.Target", [
            { no: 14, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "mob_type", kind: "enum", T: () => ["proto.MobType", MobType] },
            { no: 5, name: "stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "min_base_damage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 19, name: "damage_spread", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "swing_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "dual_wield", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "dual_wield_penalty", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "parry_haste", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "tight_enemy_damage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "suppress_dodge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "spell_school", kind: "enum", T: () => ["proto.SpellSchool", SpellSchool] },
            { no: 6, name: "tank_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "target_inputs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TargetInput }
        ]);
    }
    create(value?: PartialMessage<Target>): Target {
        const message = { id: 0, name: "", level: 0, mobType: 0, stats: [], minBaseDamage: 0, damageSpread: 0, swingSpeed: 0, dualWield: false, dualWieldPenalty: false, parryHaste: false, tightEnemyDamage: false, suppressDodge: false, spellSchool: 0, tankIndex: 0, targetInputs: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Target>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Target): Target {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 14:
                    message.id = reader.int32();
                    break;
                case /* string name */ 15:
                    message.name = reader.string();
                    break;
                case /* int32 level */ 4:
                    message.level = reader.int32();
                    break;
                case /* proto.MobType mob_type */ 3:
                    message.mobType = reader.int32();
                    break;
                case /* repeated double stats */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stats.push(reader.double());
                    else
                        message.stats.push(reader.double());
                    break;
                case /* double min_base_damage */ 7:
                    message.minBaseDamage = reader.double();
                    break;
                case /* double damage_spread */ 19:
                    message.damageSpread = reader.double();
                    break;
                case /* double swing_speed */ 8:
                    message.swingSpeed = reader.double();
                    break;
                case /* bool dual_wield */ 9:
                    message.dualWield = reader.bool();
                    break;
                case /* bool dual_wield_penalty */ 10:
                    message.dualWieldPenalty = reader.bool();
                    break;
                case /* bool parry_haste */ 12:
                    message.parryHaste = reader.bool();
                    break;
                case /* bool tight_enemy_damage */ 17:
                    message.tightEnemyDamage = reader.bool();
                    break;
                case /* bool suppress_dodge */ 16:
                    message.suppressDodge = reader.bool();
                    break;
                case /* proto.SpellSchool spell_school */ 13:
                    message.spellSchool = reader.int32();
                    break;
                case /* int32 tank_index */ 6:
                    message.tankIndex = reader.int32();
                    break;
                case /* repeated proto.TargetInput target_inputs */ 18:
                    message.targetInputs.push(TargetInput.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Target, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 14; */
        if (message.id !== 0)
            writer.tag(14, WireType.Varint).int32(message.id);
        /* string name = 15; */
        if (message.name !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.name);
        /* int32 level = 4; */
        if (message.level !== 0)
            writer.tag(4, WireType.Varint).int32(message.level);
        /* proto.MobType mob_type = 3; */
        if (message.mobType !== 0)
            writer.tag(3, WireType.Varint).int32(message.mobType);
        /* repeated double stats = 5; */
        if (message.stats.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stats.length; i++)
                writer.double(message.stats[i]);
            writer.join();
        }
        /* double min_base_damage = 7; */
        if (message.minBaseDamage !== 0)
            writer.tag(7, WireType.Bit64).double(message.minBaseDamage);
        /* double damage_spread = 19; */
        if (message.damageSpread !== 0)
            writer.tag(19, WireType.Bit64).double(message.damageSpread);
        /* double swing_speed = 8; */
        if (message.swingSpeed !== 0)
            writer.tag(8, WireType.Bit64).double(message.swingSpeed);
        /* bool dual_wield = 9; */
        if (message.dualWield !== false)
            writer.tag(9, WireType.Varint).bool(message.dualWield);
        /* bool dual_wield_penalty = 10; */
        if (message.dualWieldPenalty !== false)
            writer.tag(10, WireType.Varint).bool(message.dualWieldPenalty);
        /* bool parry_haste = 12; */
        if (message.parryHaste !== false)
            writer.tag(12, WireType.Varint).bool(message.parryHaste);
        /* bool tight_enemy_damage = 17; */
        if (message.tightEnemyDamage !== false)
            writer.tag(17, WireType.Varint).bool(message.tightEnemyDamage);
        /* bool suppress_dodge = 16; */
        if (message.suppressDodge !== false)
            writer.tag(16, WireType.Varint).bool(message.suppressDodge);
        /* proto.SpellSchool spell_school = 13; */
        if (message.spellSchool !== 0)
            writer.tag(13, WireType.Varint).int32(message.spellSchool);
        /* int32 tank_index = 6; */
        if (message.tankIndex !== 0)
            writer.tag(6, WireType.Varint).int32(message.tankIndex);
        /* repeated proto.TargetInput target_inputs = 18; */
        for (let i = 0; i < message.targetInputs.length; i++)
            TargetInput.internalBinaryWrite(message.targetInputs[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Target
 */
export const Target = new Target$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Encounter$Type extends MessageType<Encounter> {
    constructor() {
        super("proto.Encounter", [
            { no: 1, name: "duration", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "duration_variation", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "execute_proportion_20", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "execute_proportion_25", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "execute_proportion_35", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "use_health", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "targets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Target }
        ]);
    }
    create(value?: PartialMessage<Encounter>): Encounter {
        const message = { duration: 0, durationVariation: 0, executeProportion20: 0, executeProportion25: 0, executeProportion35: 0, useHealth: false, targets: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Encounter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Encounter): Encounter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double duration */ 1:
                    message.duration = reader.double();
                    break;
                case /* double duration_variation */ 2:
                    message.durationVariation = reader.double();
                    break;
                case /* double execute_proportion_20 */ 3:
                    message.executeProportion20 = reader.double();
                    break;
                case /* double execute_proportion_25 */ 7:
                    message.executeProportion25 = reader.double();
                    break;
                case /* double execute_proportion_35 */ 4:
                    message.executeProportion35 = reader.double();
                    break;
                case /* bool use_health */ 5:
                    message.useHealth = reader.bool();
                    break;
                case /* repeated proto.Target targets */ 6:
                    message.targets.push(Target.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Encounter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double duration = 1; */
        if (message.duration !== 0)
            writer.tag(1, WireType.Bit64).double(message.duration);
        /* double duration_variation = 2; */
        if (message.durationVariation !== 0)
            writer.tag(2, WireType.Bit64).double(message.durationVariation);
        /* double execute_proportion_20 = 3; */
        if (message.executeProportion20 !== 0)
            writer.tag(3, WireType.Bit64).double(message.executeProportion20);
        /* double execute_proportion_25 = 7; */
        if (message.executeProportion25 !== 0)
            writer.tag(7, WireType.Bit64).double(message.executeProportion25);
        /* double execute_proportion_35 = 4; */
        if (message.executeProportion35 !== 0)
            writer.tag(4, WireType.Bit64).double(message.executeProportion35);
        /* bool use_health = 5; */
        if (message.useHealth !== false)
            writer.tag(5, WireType.Varint).bool(message.useHealth);
        /* repeated proto.Target targets = 6; */
        for (let i = 0; i < message.targets.length; i++)
            Target.internalBinaryWrite(message.targets[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Encounter
 */
export const Encounter = new Encounter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PresetTarget$Type extends MessageType<PresetTarget> {
    constructor() {
        super("proto.PresetTarget", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "target", kind: "message", T: () => Target }
        ]);
    }
    create(value?: PartialMessage<PresetTarget>): PresetTarget {
        const message = { path: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PresetTarget>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PresetTarget): PresetTarget {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string path */ 1:
                    message.path = reader.string();
                    break;
                case /* proto.Target target */ 2:
                    message.target = Target.internalBinaryRead(reader, reader.uint32(), options, message.target);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PresetTarget, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string path = 1; */
        if (message.path !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.path);
        /* proto.Target target = 2; */
        if (message.target)
            Target.internalBinaryWrite(message.target, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.PresetTarget
 */
export const PresetTarget = new PresetTarget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PresetEncounter$Type extends MessageType<PresetEncounter> {
    constructor() {
        super("proto.PresetEncounter", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "targets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PresetTarget }
        ]);
    }
    create(value?: PartialMessage<PresetEncounter>): PresetEncounter {
        const message = { path: "", targets: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PresetEncounter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PresetEncounter): PresetEncounter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string path */ 1:
                    message.path = reader.string();
                    break;
                case /* repeated proto.PresetTarget targets */ 2:
                    message.targets.push(PresetTarget.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PresetEncounter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string path = 1; */
        if (message.path !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.path);
        /* repeated proto.PresetTarget targets = 2; */
        for (let i = 0; i < message.targets.length; i++)
            PresetTarget.internalBinaryWrite(message.targets[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.PresetEncounter
 */
export const PresetEncounter = new PresetEncounter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemSpec$Type extends MessageType<ItemSpec> {
    constructor() {
        super("proto.ItemSpec", [
            { no: 2, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "enchant", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "gems", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "suffix", kind: "enum", T: () => ["proto.Suffix", Suffix] },
            { no: 6, name: "ilvl", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "quality", kind: "enum", T: () => ["proto.ItemQuality", ItemQuality] }
        ]);
    }
    create(value?: PartialMessage<ItemSpec>): ItemSpec {
        const message = { id: 0, enchant: 0, gems: [], suffix: 0, ilvl: 0, quality: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ItemSpec>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemSpec): ItemSpec {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 2:
                    message.id = reader.int32();
                    break;
                case /* int32 enchant */ 3:
                    message.enchant = reader.int32();
                    break;
                case /* repeated int32 gems */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.gems.push(reader.int32());
                    else
                        message.gems.push(reader.int32());
                    break;
                case /* proto.Suffix suffix */ 5:
                    message.suffix = reader.int32();
                    break;
                case /* int32 ilvl */ 6:
                    message.ilvl = reader.int32();
                    break;
                case /* proto.ItemQuality quality */ 7:
                    message.quality = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemSpec, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 2; */
        if (message.id !== 0)
            writer.tag(2, WireType.Varint).int32(message.id);
        /* int32 enchant = 3; */
        if (message.enchant !== 0)
            writer.tag(3, WireType.Varint).int32(message.enchant);
        /* repeated int32 gems = 4; */
        if (message.gems.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.gems.length; i++)
                writer.int32(message.gems[i]);
            writer.join();
        }
        /* proto.Suffix suffix = 5; */
        if (message.suffix !== 0)
            writer.tag(5, WireType.Varint).int32(message.suffix);
        /* int32 ilvl = 6; */
        if (message.ilvl !== 0)
            writer.tag(6, WireType.Varint).int32(message.ilvl);
        /* proto.ItemQuality quality = 7; */
        if (message.quality !== 0)
            writer.tag(7, WireType.Varint).int32(message.quality);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ItemSpec
 */
export const ItemSpec = new ItemSpec$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EquipmentSpec$Type extends MessageType<EquipmentSpec> {
    constructor() {
        super("proto.EquipmentSpec", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemSpec }
        ]);
    }
    create(value?: PartialMessage<EquipmentSpec>): EquipmentSpec {
        const message = { items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EquipmentSpec>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EquipmentSpec): EquipmentSpec {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.ItemSpec items */ 1:
                    message.items.push(ItemSpec.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EquipmentSpec, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.ItemSpec items = 1; */
        for (let i = 0; i < message.items.length; i++)
            ItemSpec.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.EquipmentSpec
 */
export const EquipmentSpec = new EquipmentSpec$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimDatabase$Type extends MessageType<SimDatabase> {
    constructor() {
        super("proto.SimDatabase", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SimItem },
            { no: 2, name: "enchants", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SimEnchant },
            { no: 3, name: "gems", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SimGem }
        ]);
    }
    create(value?: PartialMessage<SimDatabase>): SimDatabase {
        const message = { items: [], enchants: [], gems: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimDatabase>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimDatabase): SimDatabase {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.SimItem items */ 1:
                    message.items.push(SimItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.SimEnchant enchants */ 2:
                    message.enchants.push(SimEnchant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.SimGem gems */ 3:
                    message.gems.push(SimGem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimDatabase, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.SimItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            SimItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.SimEnchant enchants = 2; */
        for (let i = 0; i < message.enchants.length; i++)
            SimEnchant.internalBinaryWrite(message.enchants[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.SimGem gems = 3; */
        for (let i = 0; i < message.gems.length; i++)
            SimGem.internalBinaryWrite(message.gems[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimDatabase
 */
export const SimDatabase = new SimDatabase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimItem$Type extends MessageType<SimItem> {
    constructor() {
        super("proto.SimItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["proto.ItemType", ItemType] },
            { no: 4, name: "armor_type", kind: "enum", T: () => ["proto.ArmorType", ArmorType] },
            { no: 5, name: "weapon_type", kind: "enum", T: () => ["proto.WeaponType", WeaponType] },
            { no: 6, name: "hand_type", kind: "enum", T: () => ["proto.HandType", HandType] },
            { no: 7, name: "ranged_weapon_type", kind: "enum", T: () => ["proto.RangedWeaponType", RangedWeaponType] },
            { no: 8, name: "stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "gem_sockets", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.GemColor", GemColor] },
            { no: 10, name: "socketBonus", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "weapon_damage_min", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "weapon_damage_max", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "weapon_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "set_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "suffix", kind: "enum", T: () => ["proto.Suffix", Suffix] },
            { no: 16, name: "ilvl", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "quality", kind: "enum", T: () => ["proto.ItemQuality", ItemQuality] }
        ]);
    }
    create(value?: PartialMessage<SimItem>): SimItem {
        const message = { id: 0, name: "", type: 0, armorType: 0, weaponType: 0, handType: 0, rangedWeaponType: 0, stats: [], gemSockets: [], socketBonus: [], weaponDamageMin: 0, weaponDamageMax: 0, weaponSpeed: 0, setName: "", suffix: 0, ilvl: 0, quality: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimItem): SimItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* proto.ItemType type */ 3:
                    message.type = reader.int32();
                    break;
                case /* proto.ArmorType armor_type */ 4:
                    message.armorType = reader.int32();
                    break;
                case /* proto.WeaponType weapon_type */ 5:
                    message.weaponType = reader.int32();
                    break;
                case /* proto.HandType hand_type */ 6:
                    message.handType = reader.int32();
                    break;
                case /* proto.RangedWeaponType ranged_weapon_type */ 7:
                    message.rangedWeaponType = reader.int32();
                    break;
                case /* repeated double stats */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stats.push(reader.double());
                    else
                        message.stats.push(reader.double());
                    break;
                case /* repeated proto.GemColor gem_sockets */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.gemSockets.push(reader.int32());
                    else
                        message.gemSockets.push(reader.int32());
                    break;
                case /* repeated double socketBonus */ 10:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.socketBonus.push(reader.double());
                    else
                        message.socketBonus.push(reader.double());
                    break;
                case /* double weapon_damage_min */ 11:
                    message.weaponDamageMin = reader.double();
                    break;
                case /* double weapon_damage_max */ 12:
                    message.weaponDamageMax = reader.double();
                    break;
                case /* double weapon_speed */ 13:
                    message.weaponSpeed = reader.double();
                    break;
                case /* string set_name */ 14:
                    message.setName = reader.string();
                    break;
                case /* proto.Suffix suffix */ 15:
                    message.suffix = reader.int32();
                    break;
                case /* int32 ilvl */ 16:
                    message.ilvl = reader.int32();
                    break;
                case /* proto.ItemQuality quality */ 17:
                    message.quality = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* proto.ItemType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* proto.ArmorType armor_type = 4; */
        if (message.armorType !== 0)
            writer.tag(4, WireType.Varint).int32(message.armorType);
        /* proto.WeaponType weapon_type = 5; */
        if (message.weaponType !== 0)
            writer.tag(5, WireType.Varint).int32(message.weaponType);
        /* proto.HandType hand_type = 6; */
        if (message.handType !== 0)
            writer.tag(6, WireType.Varint).int32(message.handType);
        /* proto.RangedWeaponType ranged_weapon_type = 7; */
        if (message.rangedWeaponType !== 0)
            writer.tag(7, WireType.Varint).int32(message.rangedWeaponType);
        /* repeated double stats = 8; */
        if (message.stats.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stats.length; i++)
                writer.double(message.stats[i]);
            writer.join();
        }
        /* repeated proto.GemColor gem_sockets = 9; */
        if (message.gemSockets.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.gemSockets.length; i++)
                writer.int32(message.gemSockets[i]);
            writer.join();
        }
        /* repeated double socketBonus = 10; */
        if (message.socketBonus.length) {
            writer.tag(10, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.socketBonus.length; i++)
                writer.double(message.socketBonus[i]);
            writer.join();
        }
        /* double weapon_damage_min = 11; */
        if (message.weaponDamageMin !== 0)
            writer.tag(11, WireType.Bit64).double(message.weaponDamageMin);
        /* double weapon_damage_max = 12; */
        if (message.weaponDamageMax !== 0)
            writer.tag(12, WireType.Bit64).double(message.weaponDamageMax);
        /* double weapon_speed = 13; */
        if (message.weaponSpeed !== 0)
            writer.tag(13, WireType.Bit64).double(message.weaponSpeed);
        /* string set_name = 14; */
        if (message.setName !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.setName);
        /* proto.Suffix suffix = 15; */
        if (message.suffix !== 0)
            writer.tag(15, WireType.Varint).int32(message.suffix);
        /* int32 ilvl = 16; */
        if (message.ilvl !== 0)
            writer.tag(16, WireType.Varint).int32(message.ilvl);
        /* proto.ItemQuality quality = 17; */
        if (message.quality !== 0)
            writer.tag(17, WireType.Varint).int32(message.quality);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimItem
 */
export const SimItem = new SimItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimEnchant$Type extends MessageType<SimEnchant> {
    constructor() {
        super("proto.SimEnchant", [
            { no: 1, name: "effect_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<SimEnchant>): SimEnchant {
        const message = { effectId: 0, stats: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimEnchant>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimEnchant): SimEnchant {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 effect_id */ 1:
                    message.effectId = reader.int32();
                    break;
                case /* repeated double stats */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stats.push(reader.double());
                    else
                        message.stats.push(reader.double());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimEnchant, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 effect_id = 1; */
        if (message.effectId !== 0)
            writer.tag(1, WireType.Varint).int32(message.effectId);
        /* repeated double stats = 2; */
        if (message.stats.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stats.length; i++)
                writer.double(message.stats[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimEnchant
 */
export const SimEnchant = new SimEnchant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimGem$Type extends MessageType<SimGem> {
    constructor() {
        super("proto.SimGem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "color", kind: "enum", T: () => ["proto.GemColor", GemColor] },
            { no: 4, name: "stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<SimGem>): SimGem {
        const message = { id: 0, name: "", color: 0, stats: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimGem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimGem): SimGem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* proto.GemColor color */ 3:
                    message.color = reader.int32();
                    break;
                case /* repeated double stats */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stats.push(reader.double());
                    else
                        message.stats.push(reader.double());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimGem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* proto.GemColor color = 3; */
        if (message.color !== 0)
            writer.tag(3, WireType.Varint).int32(message.color);
        /* repeated double stats = 4; */
        if (message.stats.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stats.length; i++)
                writer.double(message.stats[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimGem
 */
export const SimGem = new SimGem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnitReference$Type extends MessageType<UnitReference> {
    constructor() {
        super("proto.UnitReference", [
            { no: 2, name: "type", kind: "enum", T: () => ["proto.UnitReference.Type", UnitReference_Type] },
            { no: 3, name: "index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "owner", kind: "message", T: () => UnitReference },
            { no: 1, name: "target_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<UnitReference>): UnitReference {
        const message = { type: 0, index: 0, targetIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UnitReference>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnitReference): UnitReference {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference.Type type */ 2:
                    message.type = reader.int32();
                    break;
                case /* int32 index */ 3:
                    message.index = reader.int32();
                    break;
                case /* proto.UnitReference owner */ 4:
                    message.owner = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.owner);
                    break;
                case /* int32 target_index = 1 [deprecated = true];*/ 1:
                    message.targetIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnitReference, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference.Type type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* int32 index = 3; */
        if (message.index !== 0)
            writer.tag(3, WireType.Varint).int32(message.index);
        /* proto.UnitReference owner = 4; */
        if (message.owner)
            UnitReference.internalBinaryWrite(message.owner, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 target_index = 1 [deprecated = true]; */
        if (message.targetIndex !== 0)
            writer.tag(1, WireType.Varint).int32(message.targetIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UnitReference
 */
export const UnitReference = new UnitReference$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionID$Type extends MessageType<ActionID> {
    constructor() {
        super("proto.ActionID", [
            { no: 1, name: "spell_id", kind: "scalar", oneof: "rawId", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "item_id", kind: "scalar", oneof: "rawId", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "other_id", kind: "enum", oneof: "rawId", T: () => ["proto.OtherAction", OtherAction] },
            { no: 4, name: "tag", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ActionID>): ActionID {
        const message = { rawId: { oneofKind: undefined }, tag: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ActionID>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionID): ActionID {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 spell_id */ 1:
                    message.rawId = {
                        oneofKind: "spellId",
                        spellId: reader.int32()
                    };
                    break;
                case /* int32 item_id */ 2:
                    message.rawId = {
                        oneofKind: "itemId",
                        itemId: reader.int32()
                    };
                    break;
                case /* proto.OtherAction other_id */ 3:
                    message.rawId = {
                        oneofKind: "otherId",
                        otherId: reader.int32()
                    };
                    break;
                case /* int32 tag */ 4:
                    message.tag = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionID, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 spell_id = 1; */
        if (message.rawId.oneofKind === "spellId")
            writer.tag(1, WireType.Varint).int32(message.rawId.spellId);
        /* int32 item_id = 2; */
        if (message.rawId.oneofKind === "itemId")
            writer.tag(2, WireType.Varint).int32(message.rawId.itemId);
        /* proto.OtherAction other_id = 3; */
        if (message.rawId.oneofKind === "otherId")
            writer.tag(3, WireType.Varint).int32(message.rawId.otherId);
        /* int32 tag = 4; */
        if (message.tag !== 0)
            writer.tag(4, WireType.Varint).int32(message.tag);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ActionID
 */
export const ActionID = new ActionID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Glyphs$Type extends MessageType<Glyphs> {
    constructor() {
        super("proto.Glyphs", [
            { no: 1, name: "major1", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "major2", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "major3", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "minor1", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "minor2", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "minor3", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Glyphs>): Glyphs {
        const message = { major1: 0, major2: 0, major3: 0, minor1: 0, minor2: 0, minor3: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Glyphs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Glyphs): Glyphs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 major1 */ 1:
                    message.major1 = reader.int32();
                    break;
                case /* int32 major2 */ 2:
                    message.major2 = reader.int32();
                    break;
                case /* int32 major3 */ 3:
                    message.major3 = reader.int32();
                    break;
                case /* int32 minor1 */ 4:
                    message.minor1 = reader.int32();
                    break;
                case /* int32 minor2 */ 5:
                    message.minor2 = reader.int32();
                    break;
                case /* int32 minor3 */ 6:
                    message.minor3 = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Glyphs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 major1 = 1; */
        if (message.major1 !== 0)
            writer.tag(1, WireType.Varint).int32(message.major1);
        /* int32 major2 = 2; */
        if (message.major2 !== 0)
            writer.tag(2, WireType.Varint).int32(message.major2);
        /* int32 major3 = 3; */
        if (message.major3 !== 0)
            writer.tag(3, WireType.Varint).int32(message.major3);
        /* int32 minor1 = 4; */
        if (message.minor1 !== 0)
            writer.tag(4, WireType.Varint).int32(message.minor1);
        /* int32 minor2 = 5; */
        if (message.minor2 !== 0)
            writer.tag(5, WireType.Varint).int32(message.minor2);
        /* int32 minor3 = 6; */
        if (message.minor3 !== 0)
            writer.tag(6, WireType.Varint).int32(message.minor3);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Glyphs
 */
export const Glyphs = new Glyphs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Cooldown$Type extends MessageType<Cooldown> {
    constructor() {
        super("proto.Cooldown", [
            { no: 1, name: "id", kind: "message", T: () => ActionID },
            { no: 2, name: "timings", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<Cooldown>): Cooldown {
        const message = { timings: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Cooldown>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Cooldown): Cooldown {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID id */ 1:
                    message.id = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated double timings */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.timings.push(reader.double());
                    else
                        message.timings.push(reader.double());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Cooldown, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID id = 1; */
        if (message.id)
            ActionID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated double timings = 2; */
        if (message.timings.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.timings.length; i++)
                writer.double(message.timings[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Cooldown
 */
export const Cooldown = new Cooldown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Cooldowns$Type extends MessageType<Cooldowns> {
    constructor() {
        super("proto.Cooldowns", [
            { no: 1, name: "cooldowns", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Cooldown },
            { no: 2, name: "hp_percent_for_defensives", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "desync_proc_trinket1_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "desync_proc_trinket2_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Cooldowns>): Cooldowns {
        const message = { cooldowns: [], hpPercentForDefensives: 0, desyncProcTrinket1Seconds: 0, desyncProcTrinket2Seconds: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Cooldowns>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Cooldowns): Cooldowns {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.Cooldown cooldowns */ 1:
                    message.cooldowns.push(Cooldown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* double hp_percent_for_defensives */ 2:
                    message.hpPercentForDefensives = reader.double();
                    break;
                case /* int32 desync_proc_trinket1_seconds */ 3:
                    message.desyncProcTrinket1Seconds = reader.int32();
                    break;
                case /* int32 desync_proc_trinket2_seconds */ 4:
                    message.desyncProcTrinket2Seconds = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Cooldowns, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.Cooldown cooldowns = 1; */
        for (let i = 0; i < message.cooldowns.length; i++)
            Cooldown.internalBinaryWrite(message.cooldowns[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* double hp_percent_for_defensives = 2; */
        if (message.hpPercentForDefensives !== 0)
            writer.tag(2, WireType.Bit64).double(message.hpPercentForDefensives);
        /* int32 desync_proc_trinket1_seconds = 3; */
        if (message.desyncProcTrinket1Seconds !== 0)
            writer.tag(3, WireType.Varint).int32(message.desyncProcTrinket1Seconds);
        /* int32 desync_proc_trinket2_seconds = 4; */
        if (message.desyncProcTrinket2Seconds !== 0)
            writer.tag(4, WireType.Varint).int32(message.desyncProcTrinket2Seconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Cooldowns
 */
export const Cooldowns = new Cooldowns$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealingModel$Type extends MessageType<HealingModel> {
    constructor() {
        super("proto.HealingModel", [
            { no: 1, name: "hps", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "cadence_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "cadence_variation", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "inspiration_uptime", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "burst_window", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<HealingModel>): HealingModel {
        const message = { hps: 0, cadenceSeconds: 0, cadenceVariation: 0, inspirationUptime: 0, burstWindow: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<HealingModel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealingModel): HealingModel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double hps */ 1:
                    message.hps = reader.double();
                    break;
                case /* double cadence_seconds */ 2:
                    message.cadenceSeconds = reader.double();
                    break;
                case /* double cadence_variation */ 5:
                    message.cadenceVariation = reader.double();
                    break;
                case /* double inspiration_uptime */ 3:
                    message.inspirationUptime = reader.double();
                    break;
                case /* int32 burst_window */ 4:
                    message.burstWindow = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealingModel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double hps = 1; */
        if (message.hps !== 0)
            writer.tag(1, WireType.Bit64).double(message.hps);
        /* double cadence_seconds = 2; */
        if (message.cadenceSeconds !== 0)
            writer.tag(2, WireType.Bit64).double(message.cadenceSeconds);
        /* double cadence_variation = 5; */
        if (message.cadenceVariation !== 0)
            writer.tag(5, WireType.Bit64).double(message.cadenceVariation);
        /* double inspiration_uptime = 3; */
        if (message.inspirationUptime !== 0)
            writer.tag(3, WireType.Bit64).double(message.inspirationUptime);
        /* int32 burst_window = 4; */
        if (message.burstWindow !== 0)
            writer.tag(4, WireType.Varint).int32(message.burstWindow);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.HealingModel
 */
export const HealingModel = new HealingModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomRotation$Type extends MessageType<CustomRotation> {
    constructor() {
        super("proto.CustomRotation", [
            { no: 1, name: "spells", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CustomSpell }
        ]);
    }
    create(value?: PartialMessage<CustomRotation>): CustomRotation {
        const message = { spells: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CustomRotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomRotation): CustomRotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.CustomSpell spells */ 1:
                    message.spells.push(CustomSpell.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomRotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.CustomSpell spells = 1; */
        for (let i = 0; i < message.spells.length; i++)
            CustomSpell.internalBinaryWrite(message.spells[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.CustomRotation
 */
export const CustomRotation = new CustomRotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomSpell$Type extends MessageType<CustomSpell> {
    constructor() {
        super("proto.CustomSpell", [
            { no: 1, name: "spell", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "casts_per_minute", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<CustomSpell>): CustomSpell {
        const message = { spell: 0, castsPerMinute: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CustomSpell>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomSpell): CustomSpell {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 spell */ 1:
                    message.spell = reader.int32();
                    break;
                case /* double casts_per_minute */ 2:
                    message.castsPerMinute = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomSpell, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 spell = 1; */
        if (message.spell !== 0)
            writer.tag(1, WireType.Varint).int32(message.spell);
        /* double casts_per_minute = 2; */
        if (message.castsPerMinute !== 0)
            writer.tag(2, WireType.Bit64).double(message.castsPerMinute);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.CustomSpell
 */
export const CustomSpell = new CustomSpell$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemSwap$Type extends MessageType<ItemSwap> {
    constructor() {
        super("proto.ItemSwap", [
            { no: 1, name: "mh_item", kind: "message", T: () => ItemSpec },
            { no: 2, name: "oh_item", kind: "message", T: () => ItemSpec },
            { no: 3, name: "ranged_item", kind: "message", T: () => ItemSpec }
        ]);
    }
    create(value?: PartialMessage<ItemSwap>): ItemSwap {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ItemSwap>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemSwap): ItemSwap {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ItemSpec mh_item */ 1:
                    message.mhItem = ItemSpec.internalBinaryRead(reader, reader.uint32(), options, message.mhItem);
                    break;
                case /* proto.ItemSpec oh_item */ 2:
                    message.ohItem = ItemSpec.internalBinaryRead(reader, reader.uint32(), options, message.ohItem);
                    break;
                case /* proto.ItemSpec ranged_item */ 3:
                    message.rangedItem = ItemSpec.internalBinaryRead(reader, reader.uint32(), options, message.rangedItem);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemSwap, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ItemSpec mh_item = 1; */
        if (message.mhItem)
            ItemSpec.internalBinaryWrite(message.mhItem, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.ItemSpec oh_item = 2; */
        if (message.ohItem)
            ItemSpec.internalBinaryWrite(message.ohItem, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.ItemSpec ranged_item = 3; */
        if (message.rangedItem)
            ItemSpec.internalBinaryWrite(message.rangedItem, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ItemSwap
 */
export const ItemSwap = new ItemSwap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Duration$Type extends MessageType<Duration> {
    constructor() {
        super("proto.Duration", [
            { no: 1, name: "ms", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<Duration>): Duration {
        const message = { ms: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Duration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Duration): Duration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double ms */ 1:
                    message.ms = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Duration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double ms = 1; */
        if (message.ms !== 0)
            writer.tag(1, WireType.Bit64).double(message.ms);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Duration
 */
export const Duration = new Duration$Type();
